// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import styles from './Styles/CampaignManager.module.css';

// const CampaignManager = () => {
//   // State Management
//   const [campaigns, setCampaigns] = useState([]);
//   const [selectedCampaign, setSelectedCampaign] = useState(null);
//   const [selectedType, setSelectedType] = useState(null);
//   const [selectedVoters, setSelectedVoters] = useState(new Set());

//   // UI State
//   const [showCreateForm, setShowCreateForm] = useState(false);
//   const [showCampaignDetails, setShowCampaignDetails] = useState(false);
//   const [isFullscreen, setIsFullscreen] = useState(false);
//   const [loading, setLoading] = useState(false);

//   // Form State
//   const [formData, setFormData] = useState({
//     leaderName: '',
//     partyName: '',
//     leaderAddress: '',
//     leaderContact: '',
//     leaderEmail: '',
//     manifesto: '',
//     Constituency: '',
//     ConstituencyTotalVoters: ''
//   });
//   const [files, setFiles] = useState([]);
//   const [formErrors, setFormErrors] = useState({});

//   // Pagination & Search
//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [statusFilter, setStatusFilter] = useState('all');
//   const votersPerPage = 15;

//   // Notification State
//   const [notification, setNotification] = useState({ show: false, type: '', message: '' });

//   // Voter Types Configuration
//   const voterTypes = useMemo(() => [
//     {
//       key: 'query',
//       label: 'Query Agent',
//       icon: '❓',
//       color: '#3b82f6',
//       bgColor: '#eff6ff',
//       description: 'Voters with questions and concerns'
//     },
//     {
//       key: 'promise',
//       label: 'Promised Agent',
//       icon: '🤝',
//       color: '#10b981',
//       bgColor: '#f0fdf4',
//       description: 'Voters who have promised support'
//     },
//     {
//       key: 'leader',
//       label: 'Community Agent',
//       icon: '👑',
//       color: '#f59e0b',
//       bgColor: '#fffbeb',
//       description: 'Influential community leaders'
//     },
//     {
//       key: 'party',
//       label: 'Party Agent',
//       icon: '🏛️',
//       color: '#8b5cf6',
//       bgColor: '#faf5ff',
//       description: 'Registered party members'
//     },
//     {
//       key: 'influencer',
//       label: 'Influencers Agent',
//       icon: '⭐',
//       color: '#ef4444',
//       bgColor: '#fef2f2',
//       description: 'Social media influencers'
//     },
//     {
//       key: 'custom',
//       label: 'Custom Agent',
//       icon: '⚙️',
//       color: '#6b7280',
//       bgColor: '#f9fafb',
//       description: 'Custom voter category'
//     }
//   ], []);

//   // Effects
//   useEffect(() => {
//     fetchCampaigns();
//   }, []);

//   // Notification handler
//   const showNotification = useCallback((type, message) => {
//     setNotification({ show: true, type, message });
//     setTimeout(() => setNotification({ show: false, type: '', message: '' }), 4000);
//   }, []);

//   // SSE Parser Function
//   const parseSSE = useCallback(async (response) => {
//     if (!response.body) {
//       throw new Error('ReadableStream not supported');
//     }

//     const reader = response.body.getReader();
//     const decoder = new TextDecoder();
//     let fullResponse = '';

//     try {
//       while (true) {
//         const { done, value } = await reader.read();
//         if (done) break;
//         fullResponse += decoder.decode(value, { stream: true });
//       }
//     } finally {
//       reader.releaseLock();
//     }

//     console.log('Full SSE Response:', fullResponse);

//     // Parse SSE events
//     const events = fullResponse.split('\n\n').filter(event => event.trim());
//     let lastData = null;

//     for (const eventStr of events) {
//       const lines = eventStr.split('\n');
//       let eventType = 'message'; // default
//       let data = '';

//       for (const line of lines) {
//         if (line.startsWith('event: ')) {
//           eventType = line.slice(7).trim();
//         } else if (line.startsWith('data: ')) {
//           data += line.slice(6) + '\n';
//         }
//       }

//       if (data.trim()) {
//         try {
//           const parsedData = JSON.parse(data.trim());
//           console.log(`Event ${eventType}:`, parsedData);
//           lastData = parsedData;
//           // If this event has success or error, we can return early if needed
//           if (parsedData.success !== undefined || parsedData.error) {
//             return parsedData;
//           }
//         } catch (parseError) {
//           console.error('Error parsing SSE data:', parseError, data);
//         }
//       }
//     }

//     // If no specific success/error found, return the last data or throw
//     if (lastData) {
//       return lastData;
//     } else {
//       throw new Error('No valid data received from SSE stream');
//     }
//   }, []);

//   // API Functions
//   const fetchCampaigns = useCallback(async () => {
//     try {

//        const creatorId = localStorage.getItem('userId');
//       setLoading(true);
//       const response = await fetch(`https://prod.toxboxai.com/api/election-campaign/by-creator/${creatorId}`, {
//         headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
//       });

//       const result = await response.json();
//       if (result.success) {
//         setCampaigns(result.data);
//       } else {
//         showNotification('error', 'Failed to fetch campaigns');
//       }
//     } catch (error) {
//       console.error('Error fetching campaigns:', error);
//       showNotification('error', 'Network error occurred');
//     } finally {
//       setLoading(false);
//     }
//   }, [showNotification]);

//   // Form Validation
//   const validateForm = useCallback(() => {
//     const errors = {};

//     if (!formData.leaderName.trim()) errors.leaderName = 'Leader name is required';
//     if (!formData.partyName.trim()) errors.partyName = 'Party name is required';
//     if (!formData.leaderAddress.trim()) errors.leaderAddress = 'Address is required';
//     if (formData.leaderContact && !/^\+?[\d\s-()]+$/.test(formData.leaderContact)) {
//       errors.leaderContact = 'Invalid contact number';
//     }
//     if (formData.leaderEmail && !/\S+@\S+\.\S+/.test(formData.leaderEmail)) {
//       errors.leaderEmail = 'Invalid email address';
//     }
//     if (formData.ConstituencyTotalVoters &&
//         (isNaN(formData.ConstituencyTotalVoters) || parseInt(formData.ConstituencyTotalVoters) <= 0)) {
//       errors.ConstituencyTotalVoters = 'Must be a positive number';
//     }
//     if (files.length === 0) errors.files = 'At least one Excel file is required';

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   }, [formData, files]);

//   // Form Handlers
//   const handleInputChange = useCallback((e) => {
//     const { name, value } = e.target;

//     if (name === 'ConstituencyTotalVoters') {
//       const numericValue = value.replace(/[^0-9]/g, '');
//       setFormData(prev => ({ ...prev, [name]: numericValue }));
//     } else {
//       setFormData(prev => ({ ...prev, [name]: value }));
//     }

//     // Clear error when user starts typing
//     if (formErrors[name]) {
//       setFormErrors(prev => ({ ...prev, [name]: '' }));
//     }
//   }, [formErrors]);

//   const handleFileChange = useCallback((e) => {
//     const selectedFiles = Array.from(e.target.files);
//     setFiles(selectedFiles);
//     if (formErrors.files) {
//       setFormErrors(prev => ({ ...prev, files: '' }));
//     }
//   }, [formErrors.files]);

//   const handleFormSubmit = useCallback(async (e) => {
//     e.preventDefault();

//     if (!validateForm()) return;

//     setLoading(true);
//     const formDataToSend = new FormData();

//     Object.entries(formData).forEach(([key, value]) => {
//       if (value.trim()) formDataToSend.append(key, value.trim());
//     });

//     files.forEach(file => formDataToSend.append('files', file));

//     try {
//       const response = await fetch('https://prod.toxboxai.com/api/election-campaign', {
//         method: 'POST',
//         headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
//         body: formDataToSend
//       });

//       const result = await response.json();

//       if (result.success) {
//         showNotification('success', result.data.message);
//         setShowCreateForm(false);
//         resetForm();
//         fetchCampaigns();
//       } else {
//         showNotification('error', result.error);
//       }
//     } catch (error) {
//       console.error('Error creating campaign:', error);
//       showNotification('error', 'Failed to create campaign');
//     } finally {
//       setLoading(false);
//     }
//   }, [formData, files, validateForm, fetchCampaigns, showNotification]);

//   const resetForm = useCallback(() => {
//     setFormData({
//       leaderName: '',
//       partyName: '',
//       leaderAddress: '',
//       leaderContact: '',
//       leaderEmail: '',
//       manifesto: '',
//       Constituency: '',
//       ConstituencyTotalVoters: ''
//     });
//     setFiles([]);
//     setFormErrors({});
//   }, []);

//   // Campaign Management
//   const openCampaignDetails = useCallback((campaign) => {
//     setSelectedCampaign(campaign);
//     setShowCampaignDetails(true);
//     setSelectedType(null);
//     setSelectedVoters(new Set());
//   }, []);

//   const closeCampaignDetails = useCallback(() => {
//     setShowCampaignDetails(false);
//     setSelectedCampaign(null);
//     setSelectedType(null);
//     setSelectedVoters(new Set());
//     setIsFullscreen(false);
//   }, []);

//   const selectVoterType = useCallback((type) => {
//     setSelectedType(type);
//     setSelectedVoters(new Set());
//     setCurrentPage(1);
//     setSearchTerm('');
//   }, []);

//   // Voter Management
//   const getVotersByType = useCallback((type) => {
//     if (!selectedCampaign?.volterList) return [];
//     return selectedCampaign.volterList.filter(voter => voter.type === type);
//   }, [selectedCampaign]);

//   const getFilteredVoters = useCallback(() => {
//     if (!selectedType) return [];

//     let voters = getVotersByType(selectedType.key);

//     // Apply search filter
//     if (searchTerm) {
//       const search = searchTerm.toLowerCase();
//       voters = voters.filter(voter =>
//         voter.voterName?.toLowerCase().includes(search) ||
//         voter.voterId?.toLowerCase().includes(search) ||
//         voter.voterContact?.toLowerCase().includes(search) ||
//         voter.voterAddress?.toLowerCase().includes(search)
//       );
//     }

//     // Apply status filter
//     if (statusFilter !== 'all') {
//       voters = voters.filter(voter => voter.callStatus === statusFilter);
//     }

//     return voters;
//   }, [selectedType, getVotersByType, searchTerm, statusFilter]);

//   const getPaginatedVoters = useCallback(() => {
//     const filteredVoters = getFilteredVoters();
//     const startIndex = (currentPage - 1) * votersPerPage;
//     return filteredVoters.slice(startIndex, startIndex + votersPerPage);
//   }, [getFilteredVoters, currentPage, votersPerPage]);

//   const getTypeStatistics = useCallback(() => {
//     if (!selectedCampaign?.volterList) return {};

//     return voterTypes.reduce((stats, type) => {
//       const voters = getVotersByType(type.key);
//       stats[type.key] = {
//         total: voters.length,
//         notCalled: voters.filter(v => v.callStatus === 'not_called').length,
//         completed: voters.filter(v => v.callStatus === 'completed').length,
//         missed: voters.filter(v => v.callStatus === 'missed').length
//       };
//       return stats;
//     }, {});
//   }, [selectedCampaign, voterTypes, getVotersByType]);

//   // Selection Management
//   const toggleVoterSelection = useCallback((voterId) => {
//     setSelectedVoters(prev => {
//       const newSelection = new Set(prev);
//       if (newSelection.has(voterId)) {
//         newSelection.delete(voterId);
//       } else {
//         newSelection.add(voterId);
//       }
//       return newSelection;
//     });
//   }, []);

//   const toggleSelectAll = useCallback(() => {
//     const filteredVoters = getFilteredVoters();
//     const allSelected = filteredVoters.every(voter => selectedVoters.has(voter._id));

//     if (allSelected) {
//       setSelectedVoters(new Set());
//     } else {
//       setSelectedVoters(new Set(filteredVoters.map(v => v._id)));
//     }
//   }, [getFilteredVoters, selectedVoters]);

//   // Call Management
//   const handleBulkCall = useCallback(async (type = 'selected') => {
//     console.log('handleBulkCall called with type:', type);
//     const votersToCall = type === 'all'
//       ? getFilteredVoters()
//       : getFilteredVoters().filter(voter => selectedVoters.has(voter._id));

//     console.log('Voters to call:', votersToCall);

//     if (votersToCall.length === 0) {
//       showNotification('warning', 'No voters selected for calling');
//       return;
//     }

//     const agentId = selectedCampaign?.linkedPromptTemplate?.agentId;
//     const promptId = selectedCampaign?.linkedPromptTemplate?.promptID;
//     console.log('Agent ID:', agentId);
//     console.log('Prompt ID:', promptId);

//     if (!agentId) {
//       showNotification('error', 'No agent assigned to this campaign');
//       return;
//     }

//     const calls = votersToCall
//       .filter(voter => voter.voterContact)
//       .map(voter => ({
//         toNumber: voter.voterContact,
//         fromNumber: "+918035738038",
//         customerName: voter.voterName
//       }));

//     console.log('Calls array:', calls);

//     if (calls.length === 0) {
//       showNotification('warning', 'No voters with contact numbers selected');
//       return;
//     }

//     const payload = {
//       assignedAgentId: agentId,
//       promptId: promptId,
//       calls: calls
//     };

//     console.log('Sending payload:', payload);

//     try {
//       setLoading(true);
//       const token = localStorage.getItem('token');
//       console.log('Token exists:', !!token);

//       const response = await fetch('https://prod.toxboxai.com/api/election-call/initiate-call', {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(payload)
//       });

//       console.log('Response status:', response.status);
//       console.log('Response headers:', [...response.headers.entries()]);

//       const result = await parseSSE(response);
//       console.log('Parsed SSE Result:', result);

//       if (result.success) {
//         showNotification('success', `Initiated calls for ${calls.length} voters`);
//         if (type === 'selected') {
//           setSelectedVoters(new Set());
//         }
//         fetchCampaigns();
//       } else {
//         showNotification('error', result.error || 'Failed to initiate calls');
//       }
//     } catch (error) {
//       console.error('Error initiating calls:', error);
//       showNotification('error', 'Network error occurred');
//     } finally {
//       setLoading(false);
//     }
//   }, [getFilteredVoters, selectedVoters, showNotification, selectedCampaign, fetchCampaigns, parseSSE]);

//   // Computed Values
//   const typeStats = getTypeStatistics();
//   const filteredVoters = getFilteredVoters();
//   const paginatedVoters = getPaginatedVoters();
//   const totalPages = Math.ceil(filteredVoters.length / votersPerPage);
//   const isAllSelected = filteredVoters.length > 0 &&
//     filteredVoters.every(voter => selectedVoters.has(voter._id));

//   // Utility Functions
//   const formatNumber = (num) => new Intl.NumberFormat('en-IN').format(num);
//   const formatDate = (date) => new Date(date).toLocaleDateString('en-IN', {
//     year: 'numeric',
//     month: 'short',
//     day: 'numeric'
//   });

//   const getStatusBadge = (status) => {
//     const badges = {
//       not_called: { label: 'Not Called', class: styles.statusNotCalled },
//       completed: { label: 'Completed', class: styles.statusCompleted },
//       missed: { label: 'Missed', class: styles.statusMissed }
//     };

//     const badge = badges[status] || badges.not_called;
//     return <span className={`${styles.statusBadge} ${badge.class}`}>{badge.label}</span>;
//   };

//   return (
//     <div className={styles.campaignManager}>
//       {/* Notification */}
//       {notification.show && (
//         <div className={`${styles.notification} ${styles[notification.type]} ${styles.show}`}>
//           <div className={styles.notificationContent}>
//             <span className={styles.notificationIcon}>
//               {notification.type === 'success' && '✅'}
//               {notification.type === 'error' && '❌'}
//               {notification.type === 'warning' && '⚠️'}
//               {notification.type === 'info' && 'ℹ️'}
//             </span>
//             <span className={styles.notificationMessage}>{notification.message}</span>
//           </div>
//         </div>
//       )}

//       {/* Header */}
//       <header className={styles.header}>
//         <div className={styles.headerContent}>
//           <div className={styles.headerLeft}>
//             <h1 className={styles.title}>Election Campaign Manager</h1>
//             <p className={styles.subtitle}>Manage your electoral campaigns efficiently</p>
//           </div>
//           <div className={styles.headerRight}>
//             <button
//               className={styles.primaryButton}
//               onClick={() => setShowCreateForm(true)}
//               disabled={loading}
//             >
//               <span className={styles.buttonIcon}>+</span>
//               New Campaign
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* Main Content */}
//       <main className={styles.mainContent}>
//         {loading && campaigns.length === 0 ? (
//           <div className={styles.loadingState}>
//             <div className={styles.spinner}></div>
//             <p>Loading campaigns...</p>
//           </div>
//         ) : campaigns.length === 0 ? (
//           <div className={styles.emptyState}>
//             <div className={styles.emptyStateIcon}>🗳️</div>
//             <h2>No Campaigns Yet</h2>
//             <p>Create your first election campaign to get started</p>
//             <button
//               className={styles.primaryButton}
//               onClick={() => setShowCreateForm(true)}
//             >
//               Create First Campaign
//             </button>
//           </div>
//         ) : (
//           <div className={styles.campaignsGrid}>
//             {campaigns.map((campaign) => (
//               <div key={campaign._id} className={styles.campaignCard}>
//                 <div className={styles.cardHeader}>
//                   <div className={styles.cardHeaderLeft}>
//                     <h3 className={styles.cardTitle}>{campaign.leaderName}</h3>
//                     <span className={styles.partyBadge}>{campaign.partyName}</span>
//                   </div>
//                   <div className={styles.cardHeaderRight}>
//                     <span className={styles.voterCount}>
//                       {campaign.volterList?.length || 0} voters
//                     </span>
//                   </div>
//                 </div>

//                 <div className={styles.cardBody}>
//                   <div className={styles.cardInfo}>
//                     <p><strong>Address:</strong> {campaign.leaderAddress}</p>
//                     {campaign.Constituency && (
//                       <p><strong>Constituency:</strong> {campaign.Constituency}</p>
//                     )}
//                     {campaign.ConstituencyTotalVoters && (
//                       <div className={styles.coverageInfo}>
//                         <p><strong>Total Voters:</strong> {formatNumber(campaign.ConstituencyTotalVoters)}</p>
//                         <div className={styles.coverageProgress}>
//                           <div className={styles.progressBar}>
//                             <div
//                               className={styles.progressFill}
//                               style={{
//                                 width: `${Math.min((campaign.volterList?.length || 0) / campaign.ConstituencyTotalVoters * 100, 100)}%`
//                               }}
//                             ></div>
//                           </div>
//                           <span className={styles.coverageText}>
//                             {((campaign.volterList?.length || 0) / campaign.ConstituencyTotalVoters * 100).toFixed(1)}% coverage
//                           </span>
//                         </div>
//                       </div>
//                     )}
//                     <p><strong>Created:</strong> {formatDate(campaign.createdAt)}</p>
//                   </div>
//                 </div>

//                 <div className={styles.cardFooter}>
//                   <button
//                     className={styles.secondaryButton}
//                     onClick={() => openCampaignDetails(campaign)}
//                   >
//                     View Details
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </main>

//       {/* Create Campaign Modal */}
//       {showCreateForm && (
//         <div className={styles.modal}>
//           <div className={styles.modalOverlay} onClick={() => setShowCreateForm(false)}></div>
//           <div className={styles.modalContent}>
//             <div className={styles.modalHeader}>
//               <h2>Create New Campaign</h2>
//               <button
//                 className={styles.modalClose}
//                 onClick={() => setShowCreateForm(false)}
//               >
//                 ×
//               </button>
//             </div>

//             <form onSubmit={handleFormSubmit} className={styles.form}>
//               <div className={styles.formSection}>
//                 <h3 className={styles.sectionTitle}>Basic Information</h3>

//                 <div className={styles.formGrid}>
//                   <div className={styles.formGroup}>
//                     <label className={styles.label}>Leader Name *</label>
//                     <input
//                       type="text"
//                       name="leaderName"
//                       value={formData.leaderName}
//                       onChange={handleInputChange}
//                       className={`${styles.input} ${formErrors.leaderName ? styles.inputError : ''}`}
//                       placeholder="Enter leader name"
//                     />
//                     {formErrors.leaderName && (
//                       <span className={styles.errorText}>{formErrors.leaderName}</span>
//                     )}
//                   </div>

//                   <div className={styles.formGroup}>
//                     <label className={styles.label}>Party Name *</label>
//                     <input
//                       type="text"
//                       name="partyName"
//                       value={formData.partyName}
//                       onChange={handleInputChange}
//                       className={`${styles.input} ${formErrors.partyName ? styles.inputError : ''}`}
//                       placeholder="Enter party name"
//                     />
//                     {formErrors.partyName && (
//                       <span className={styles.errorText}>{formErrors.partyName}</span>
//                     )}
//                   </div>

//                   <div className={styles.formGroup}>
//                     <label className={styles.label}>Contact Number</label>
//                     <input
//                       type="tel"
//                       name="leaderContact"
//                       value={formData.leaderContact}
//                       onChange={handleInputChange}
//                       className={`${styles.input} ${formErrors.leaderContact ? styles.inputError : ''}`}
//                       placeholder="Enter contact number"
//                     />
//                     {formErrors.leaderContact && (
//                       <span className={styles.errorText}>{formErrors.leaderContact}</span>
//                     )}
//                   </div>

//                   <div className={styles.formGroup}>
//                     <label className={styles.label}>Email Address</label>
//                     <input
//                       type="email"
//                       name="leaderEmail"
//                       value={formData.leaderEmail}
//                       onChange={handleInputChange}
//                       className={`${styles.input} ${formErrors.leaderEmail ? styles.inputError : ''}`}
//                       placeholder="Enter email address"
//                     />
//                     {formErrors.leaderEmail && (
//                       <span className={styles.errorText}>{formErrors.leaderEmail}</span>
//                     )}
//                   </div>
//                 </div>

//                 <div className={styles.formGroup}>
//                   <label className={styles.label}>Address *</label>
//                   <textarea
//                     name="leaderAddress"
//                     value={formData.leaderAddress}
//                     onChange={handleInputChange}
//                     className={`${styles.textarea} ${formErrors.leaderAddress ? styles.inputError : ''}`}
//                     placeholder="Enter complete address"
//                     rows="3"
//                   />
//                   {formErrors.leaderAddress && (
//                     <span className={styles.errorText}>{formErrors.leaderAddress}</span>
//                   )}
//                 </div>
//               </div>

//               <div className={styles.formSection}>
//                 <h3 className={styles.sectionTitle}>Constituency Information</h3>

//                 <div className={styles.formGrid}>
//                   <div className={styles.formGroup}>
//                     <label className={styles.label}>Constituency</label>
//                     <input
//                       type="text"
//                       name="Constituency"
//                       value={formData.Constituency}
//                       onChange={handleInputChange}
//                       className={styles.input}
//                       placeholder="Enter constituency name"
//                     />
//                   </div>

//                   <div className={styles.formGroup}>
//                     <label className={styles.label}>Total Constituency Voters</label>
//                     <input
//                       type="text"
//                       name="ConstituencyTotalVoters"
//                       value={formData.ConstituencyTotalVoters}
//                       onChange={handleInputChange}
//                       className={`${styles.input} ${formErrors.ConstituencyTotalVoters ? styles.inputError : ''}`}
//                       placeholder="Enter total voters"
//                     />
//                     {formErrors.ConstituencyTotalVoters && (
//                       <span className={styles.errorText}>{formErrors.ConstituencyTotalVoters}</span>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               <div className={styles.formSection}>
//                 <h3 className={styles.sectionTitle}>Campaign Details</h3>

//                 <div className={styles.formGroup}>
//                   <label className={styles.label}>Manifesto</label>
//                   <textarea
//                     name="manifesto"
//                     value={formData.manifesto}
//                     onChange={handleInputChange}
//                     className={styles.textarea}
//                     placeholder="Enter campaign manifesto and promises"
//                     rows="4"
//                   />
//                 </div>

//                 <div className={styles.formGroup}>
//                   <label className={styles.label}>Voter Data Files *</label>
//                   <div className={styles.fileUpload}>
//                     <input
//                       type="file"
//                       multiple
//                       accept=".xlsx,.xls"
//                       onChange={handleFileChange}
//                       className={styles.fileInput}
//                       id="voter-files"
//                     />
//                     <label
//                       htmlFor="voter-files"
//                       className={`${styles.fileLabel} ${formErrors.files ? styles.inputError : ''}`}
//                     >
//                       <span className={styles.fileIcon}>📁</span>
//                       <span>Choose Excel files or drag and drop</span>
//                     </label>
//                   </div>
//                   {formErrors.files && (
//                     <span className={styles.errorText}>{formErrors.files}</span>
//                   )}

//                   {files.length > 0 && (
//                     <div className={styles.fileList}>
//                       {files.map((file, index) => (
//                         <div key={index} className={styles.fileItem}>
//                           <span className={styles.fileName}>📄 {file.name}</span>
//                           <span className={styles.fileSize}>
//                             {(file.size / 1024).toFixed(1)} KB
//                           </span>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </div>

//               <div className={styles.formActions}>
//                 <button
//                   type="button"
//                   className={styles.secondaryButton}
//                   onClick={() => setShowCreateForm(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className={styles.primaryButton}
//                   disabled={loading}
//                 >
//                   {loading ? (
//                     <>
//                       <span className={styles.spinner}></span>
//                       Creating...
//                     </>
//                   ) : (
//                     'Create Campaign'
//                   )}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Campaign Details Modal */}
//       {showCampaignDetails && selectedCampaign && (
//         <div className={`${styles.modal} ${isFullscreen ? styles.fullscreen : ''}`}>
//           <div className={styles.modalOverlay} onClick={closeCampaignDetails}></div>
//           <div className={styles.modalContent}>
//             <div className={styles.modalHeader}>
//               <div className={styles.modalHeaderLeft}>
//                 {selectedType && (
//                   <button
//                     className={styles.backButton}
//                     onClick={() => setSelectedType(null)}
//                   >
//                     ← Back
//                   </button>
//                 )}
//                 <div>
//                   <h2>
//                     {selectedType ? `${selectedType.label}` : selectedCampaign.leaderName}
//                   </h2>
//                   <span className={styles.partyBadge}>{selectedCampaign.partyName}</span>
//                 </div>
//               </div>
//               <div className={styles.modalHeaderRight}>
//                 <button
//                   className={styles.fullscreenButton}
//                   onClick={() => setIsFullscreen(!isFullscreen)}
//                 >
//                   {isFullscreen ? '⤢' : '⤡'}
//                 </button>
//                 <button
//                   className={styles.modalClose}
//                   onClick={closeCampaignDetails}
//                 >
//                   ×
//                 </button>
//               </div>
//             </div>

//             <div className={styles.modalBody}>
//               {!selectedType ? (
//                 // Campaign Overview
//                 <div className={styles.campaignOverview}>
//                   <div className={styles.campaignInfo}>
//                     <div className={styles.infoGrid}>
//                       <div className={styles.infoCard}>
//                         <h4>Contact Information</h4>
//                         <p><strong>Address:</strong> {selectedCampaign.leaderAddress}</p>
//                         {selectedCampaign.leaderContact && (
//                           <p><strong>Phone:</strong> {selectedCampaign.leaderContact}</p>
//                         )}
//                         {selectedCampaign.leaderEmail && (
//                           <p><strong>Email:</strong> {selectedCampaign.leaderEmail}</p>
//                         )}
//                       </div>

//                       <div className={styles.infoCard}>
//                         <h4>Constituency Details</h4>
//                         {selectedCampaign.Constituency ? (
//                           <p><strong>Constituency:</strong> {selectedCampaign.Constituency}</p>
//                         ) : (
//                           <p>No constituency information</p>
//                         )}
//                         {selectedCampaign.ConstituencyTotalVoters && (
//                           <>
//                             <p><strong>Total Voters:</strong> {formatNumber(selectedCampaign.ConstituencyTotalVoters)}</p>
//                             <div className={styles.coverageMetric}>
//                               <div className={styles.coverageBar}>
//                                 <div
//                                   className={styles.coverageFill}
//                                   style={{
//                                     width: `${Math.min((selectedCampaign.volterList?.length || 0) / selectedCampaign.ConstituencyTotalVoters * 100, 100)}%`
//                                   }}
//                                 ></div>
//                               </div>
//                               <span>
//                                 {((selectedCampaign.volterList?.length || 0) / selectedCampaign.ConstituencyTotalVoters * 100).toFixed(1)}% Coverage
//                               </span>
//                             </div>
//                           </>
//                         )}
//                       </div>

//                       <div className={styles.infoCard}>
//                         <h4>Campaign Stats</h4>
//                         <p><strong>Total Voters:</strong> {selectedCampaign.volterList?.length || 0}</p>
//                         <p><strong>Created:</strong> {formatDate(selectedCampaign.createdAt)}</p>
//                         <p><strong>Created by:</strong> {selectedCampaign.createdBy?.email || 'N/A'}</p>
//                       </div>
//                     </div>

//                     {selectedCampaign.manifesto && (
//                       <div className={styles.manifestoCard}>
//                         <h4>Campaign Manifesto</h4>
//                         <p>{selectedCampaign.manifesto}</p>
//                       </div>
//                     )}
//                   </div>

//                   <div className={styles.voterTypesSection}>
//                     <h3>Voter Categories</h3>
//                     <div className={styles.typeCards}>
//                       {voterTypes.map(type => {
//                         const stats = typeStats[type.key] || { total: 0, notCalled: 0, completed: 0, missed: 0 };
//                         return (
//                           <div
//                             key={type.key}
//                             className={styles.typeCard}
//                             onClick={() => selectVoterType(type)}
//                             style={{ backgroundColor: type.bgColor, borderColor: type.color }}
//                           >
//                             <div className={styles.typeCardHeader}>
//                               <div className={styles.typeCardIcon} style={{ color: type.color }}>
//                                 {type.icon}
//                               </div>
//                               <div className={styles.typeCardInfo}>
//                                 <h4>{type.label}</h4>
//                                 <p>{type.description}</p>
//                               </div>
//                               <div className={styles.typeCardCount} style={{ backgroundColor: type.color }}>
//                                 {stats.total}
//                               </div>
//                             </div>

//                             <div className={styles.typeCardStats}>
//                               <div className={styles.statItem}>
//                                 <span className={styles.statValue}>{stats.notCalled}</span>
//                                 <span className={styles.statLabel}>Not Called</span>
//                               </div>
//                               <div className={styles.statItem}>
//                                 <span className={styles.statValue}>{stats.completed}</span>
//                                 <span className={styles.statLabel}>Completed</span>
//                               </div>
//                               <div className={styles.statItem}>
//                                 <span className={styles.statValue}>{stats.missed}</span>
//                                 <span className={styles.statLabel}>Missed</span>
//                               </div>
//                             </div>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 // Voter List for Selected Type
//                 <div className={styles.voterManagement}>
//                   <div className={styles.voterControls}>
//                     <div className={styles.searchAndFilter}>
//                       <div className={styles.searchBox}>
//                         <input
//                           type="text"
//                           placeholder="Search voters..."
//                           value={searchTerm}
//                           onChange={(e) => {
//                             setSearchTerm(e.target.value);
//                             setCurrentPage(1);
//                           }}
//                           className={styles.searchInput}
//                         />
//                       </div>

//                       <select
//                         value={statusFilter}
//                         onChange={(e) => {
//                           setStatusFilter(e.target.value);
//                           setCurrentPage(1);
//                         }}
//                         className={styles.filterSelect}
//                       >
//                         <option value="all">All Status</option>
//                         <option value="not_called">Not Called</option>
//                         <option value="completed">Completed</option>
//                         <option value="missed">Missed</option>
//                       </select>
//                     </div>

//                     <div className={styles.bulkActions}>
//                       <button
//                         className={styles.secondaryButton}
//                         onClick={() => handleBulkCall('selected')}
//                         disabled={selectedVoters.size === 0 || loading}
//                       >
//                         📞 Call Selected ({selectedVoters.size})
//                       </button>
//                       <button
//                         className={styles.primaryButton}
//                         onClick={() => handleBulkCall('all')}
//                         disabled={filteredVoters.length === 0 || loading}
//                       >
//                         📞 Call All ({filteredVoters.length})
//                       </button>
//                     </div>
//                   </div>

//                   {filteredVoters.length > 0 ? (
//                     <>
//                       <div className={styles.voterTable}>
//                         <table>
//                           <thead>
//                             <tr>
//                               <th>
//                                 <input
//                                   type="checkbox"
//                                   checked={isAllSelected}
//                                   onChange={toggleSelectAll}
//                                 />
//                               </th>
//                               <th>Voter ID</th>
//                               <th>Name</th>
//                               <th>Contact</th>
//                               <th>Address</th>
//                               <th>Status</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {paginatedVoters.map((voter) => (
//                               <tr key={voter._id}>
//                                 <td>
//                                   <input
//                                     type="checkbox"
//                                     checked={selectedVoters.has(voter._id)}
//                                     onChange={() => toggleVoterSelection(voter._id)}
//                                   />
//                                 </td>
//                                 <td>{voter.voterId || 'N/A'}</td>
//                                 <td>{voter.voterName || 'N/A'}</td>
//                                 <td>{voter.voterContact || 'N/A'}</td>
//                                 <td className={styles.addressCell}>{voter.voterAddress || 'N/A'}</td>
//                                 <td>{getStatusBadge(voter.callStatus)}</td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>

//                       {totalPages > 1 && (
//                         <div className={styles.pagination}>
//                           <button
//                             onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//                             disabled={currentPage === 1}
//                             className={styles.paginationButton}
//                           >
//                             ← Previous
//                           </button>

//                           <div className={styles.pageNumbers}>
//                             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                               const page = Math.max(1, currentPage - 2) + i;
//                               if (page > totalPages) return null;

//                               return (
//                                 <button
//                                   key={page}
//                                   onClick={() => setCurrentPage(page)}
//                                   className={`${styles.pageNumber} ${currentPage === page ? styles.active : ''}`}
//                                 >
//                                   {page}
//                                 </button>
//                               );
//                             })}
//                           </div>

//                           <button
//                             onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
//                             disabled={currentPage === totalPages}
//                             className={styles.paginationButton}
//                           >
//                             Next →
//                           </button>
//                         </div>
//                       )}

//                       <div className={styles.tableFooter}>
//                         Showing {((currentPage - 1) * votersPerPage) + 1} to{' '}
//                         {Math.min(currentPage * votersPerPage, filteredVoters.length)} of{' '}
//                         {filteredVoters.length} voters
//                       </div>
//                     </>
//                   ) : (
//                     <div className={styles.emptyState}>
//                       <div className={styles.emptyStateIcon}>🔍</div>
//                       <h3>No voters found</h3>
//                       <p>Try adjusting your search or filter criteria</p>
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CampaignManager;
// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import styles from './Styles/CampaignManager.module.css';

// const CampaignManager = () => {
//   // State Management
//   const [campaigns, setCampaigns] = useState([]);
//   const [selectedCampaign, setSelectedCampaign] = useState(null);
//   const [selectedType, setSelectedType] = useState(null);
//   const [selectedVoters, setSelectedVoters] = useState(new Set());

//   // UI State
//   const [showCreateForm, setShowCreateForm] = useState(false);
//   const [showCampaignDetails, setShowCampaignDetails] = useState(false);
//   const [isFullscreen, setIsFullscreen] = useState(false);
//   const [loading, setLoading] = useState(false);

//   // Form State
//   const [formData, setFormData] = useState({
//     leaderName: '',
//     partyName: '',
//     leaderAddress: '',
//     leaderContact: '',
//     leaderEmail: '',
//     manifesto: '',
//     Constituency: '',
//     ConstituencyTotalVoters: ''
//   });
//   const [files, setFiles] = useState([]);
//   const [formErrors, setFormErrors] = useState({});

//   // Pagination & Search
//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [statusFilter, setStatusFilter] = useState('all');
//   const votersPerPage = 15;

//   // Notification State
//   const [notification, setNotification] = useState({ show: false, type: '', message: '' });

//   // Voter Types Configuration
//   const voterTypes = useMemo(() => [
//     {
//       key: 'query',
//       label: 'Query Agent',
//       icon: '❓',
//       color: '#3b82f6',
//       bgColor: '#eff6ff',
//       description: 'Voters with questions and concerns'
//     },
//     {
//       key: 'promise',
//       label: 'Promised Agent',
//       icon: '🤝',
//       color: '#10b981',
//       bgColor: '#f0fdf4',
//       description: 'Voters who have promised support'
//     },
//     {
//       key: 'leader',
//       label: 'Community Agent',
//       icon: '👑',
//       color: '#f59e0b',
//       bgColor: '#fffbeb',
//       description: 'Influential community leaders'
//     },
//     {
//       key: 'party',
//       label: 'Party Agent',
//       icon: '🏛️',
//       color: '#8b5cf6',
//       bgColor: '#faf5ff',
//       description: 'Registered party members'
//     },
//     {
//       key: 'influencer',
//       label: 'Influencers Agent',
//       icon: '⭐',
//       color: '#ef4444',
//       bgColor: '#fef2f2',
//       description: 'Social media influencers'
//     },
//     {
//       key: 'custom',
//       label: 'Custom Agent',
//       icon: '⚙️',
//       color: '#6b7280',
//       bgColor: '#f9fafb',
//       description: 'Custom voter category'
//     }
//   ], []);

//   // Effects
//   useEffect(() => {
//     fetchCampaigns();
//   }, []);

//   // Notification handler
//   const showNotification = useCallback((type, message) => {
//     setNotification({ show: true, type, message });
//     setTimeout(() => setNotification({ show: false, type: '', message: '' }), 4000);
//   }, []);

//   // SSE Parser Function
//   const parseSSE = useCallback(async (response) => {
//     if (!response.body) {
//       throw new Error('ReadableStream not supported');
//     }

//     const reader = response.body.getReader();
//     const decoder = new TextDecoder();
//     let fullResponse = '';

//     try {
//       while (true) {
//         const { done, value } = await reader.read();
//         if (done) break;
//         fullResponse += decoder.decode(value, { stream: true });
//       }
//     } finally {
//       reader.releaseLock();
//     }

//     console.log('Full SSE Response:', fullResponse);

//     // Parse SSE events
//     const events = fullResponse.split('\n\n').filter(event => event.trim());
//     let lastData = null;

//     for (const eventStr of events) {
//       const lines = eventStr.split('\n');
//       let eventType = 'message'; // default
//       let data = '';

//       for (const line of lines) {
//         if (line.startsWith('event: ')) {
//           eventType = line.slice(7).trim();
//         } else if (line.startsWith('data: ')) {
//           data += line.slice(6) + '\n';
//         }
//       }

//       if (data.trim()) {
//         try {
//           const parsedData = JSON.parse(data.trim());
//           console.log(`Event ${eventType}:`, parsedData);
//           lastData = parsedData;
//           // If this event has success or error, we can return early if needed
//           if (parsedData.success !== undefined || parsedData.error) {
//             return parsedData;
//           }
//         } catch (parseError) {
//           console.error('Error parsing SSE data:', parseError, data);
//         }
//       }
//     }

//     // If no specific success/error found, return the last data or throw
//     if (lastData) {
//       return lastData;
//     } else {
//       throw new Error('No valid data received from SSE stream');
//     }
//   }, []);

//   // API Functions
//   const fetchCampaigns = useCallback(async () => {
//     try {

//        const creatorId = localStorage.getItem('userId');
//       setLoading(true);
//       const response = await fetch(`https://prod.toxboxai.com/api/election-campaign/by-creator/${creatorId}`, {
//         headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
//       });

//       const result = await response.json();
//       if (result.success) {
//         setCampaigns(result.data);
//       } else {
//         showNotification('error', 'Failed to fetch campaigns');
//       }
//     } catch (error) {
//       console.error('Error fetching campaigns:', error);
//       showNotification('error', 'Network error occurred');
//     } finally {
//       setLoading(false);
//     }
//   }, [showNotification]);

//   // Form Validation
//   const validateForm = useCallback(() => {
//     const errors = {};

//     if (!formData.leaderName.trim()) errors.leaderName = 'Leader name is required';
//     if (!formData.partyName.trim()) errors.partyName = 'Party name is required';
//     if (!formData.leaderAddress.trim()) errors.leaderAddress = 'Address is required';
//     if (formData.leaderContact && !/^\+?[\d\s-()]+$/.test(formData.leaderContact)) {
//       errors.leaderContact = 'Invalid contact number';
//     }
//     if (formData.leaderEmail && !/\S+@\S+\.\S+/.test(formData.leaderEmail)) {
//       errors.leaderEmail = 'Invalid email address';
//     }
//     if (formData.ConstituencyTotalVoters &&
//         (isNaN(formData.ConstituencyTotalVoters) || parseInt(formData.ConstituencyTotalVoters) <= 0)) {
//       errors.ConstituencyTotalVoters = 'Must be a positive number';
//     }
//     if (files.length === 0) errors.files = 'At least one Excel file is required';

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   }, [formData, files]);

//   // Form Handlers
//   const handleInputChange = useCallback((e) => {
//     const { name, value } = e.target;

//     if (name === 'ConstituencyTotalVoters') {
//       const numericValue = value.replace(/[^0-9]/g, '');
//       setFormData(prev => ({ ...prev, [name]: numericValue }));
//     } else {
//       setFormData(prev => ({ ...prev, [name]: value }));
//     }

//     // Clear error when user starts typing
//     if (formErrors[name]) {
//       setFormErrors(prev => ({ ...prev, [name]: '' }));
//     }
//   }, [formErrors]);

//   const handleFileChange = useCallback((e) => {
//     const selectedFiles = Array.from(e.target.files);
//     setFiles(selectedFiles);
//     if (formErrors.files) {
//       setFormErrors(prev => ({ ...prev, files: '' }));
//     }
//   }, [formErrors.files]);

//   const handleFormSubmit = useCallback(async (e) => {
//     e.preventDefault();

//     if (!validateForm()) return;

//     setLoading(true);
//     const formDataToSend = new FormData();

//     Object.entries(formData).forEach(([key, value]) => {
//       if (value.trim()) formDataToSend.append(key, value.trim());
//     });

//     files.forEach(file => formDataToSend.append('files', file));

//     try {
//       const response = await fetch('https://prod.toxboxai.com/api/election-campaign', {
//         method: 'POST',
//         headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
//         body: formDataToSend
//       });

//       const result = await response.json();

//       if (result.success) {
//         showNotification('success', result.data.message);
//         setShowCreateForm(false);
//         resetForm();
//         fetchCampaigns();
//       } else {
//         showNotification('error', result.error);
//       }
//     } catch (error) {
//       console.error('Error creating campaign:', error);
//       showNotification('error', 'Failed to create campaign');
//     } finally {
//       setLoading(false);
//     }
//   }, [formData, files, validateForm, fetchCampaigns, showNotification]);

//   const resetForm = useCallback(() => {
//     setFormData({
//       leaderName: '',
//       partyName: '',
//       leaderAddress: '',
//       leaderContact: '',
//       leaderEmail: '',
//       manifesto: '',
//       Constituency: '',
//       ConstituencyTotalVoters: ''
//     });
//     setFiles([]);
//     setFormErrors({});
//   }, []);

//   // Campaign Management
//   const openCampaignDetails = useCallback((campaign) => {
//     setSelectedCampaign(campaign);
//     setShowCampaignDetails(true);
//     setSelectedType(null);
//     setSelectedVoters(new Set());
//   }, []);

//   const closeCampaignDetails = useCallback(() => {
//     setShowCampaignDetails(false);
//     setSelectedCampaign(null);
//     setSelectedType(null);
//     setSelectedVoters(new Set());
//     setIsFullscreen(false);
//   }, []);

//   const selectVoterType = useCallback((type) => {
//     setSelectedType(type);
//     setSelectedVoters(new Set());
//     setCurrentPage(1);
//     setSearchTerm('');
//   }, []);

//   // Voter Management
//   const getVotersByType = useCallback((type) => {
//     if (!selectedCampaign?.volterList) return [];
//     return selectedCampaign.volterList.filter(voter => voter.type === type);
//   }, [selectedCampaign]);

//   const getFilteredVoters = useCallback(() => {
//     if (!selectedType) return [];

//     let voters = getVotersByType(selectedType.key);

//     // Apply search filter
//     if (searchTerm) {
//       const search = searchTerm.toLowerCase();
//       voters = voters.filter(voter =>
//         voter.voterName?.toLowerCase().includes(search) ||
//         voter.voterId?.toLowerCase().includes(search) ||
//         voter.voterContact?.toLowerCase().includes(search) ||
//         voter.voterAddress?.toLowerCase().includes(search)
//       );
//     }

//     // Apply status filter
//     if (statusFilter !== 'all') {
//       voters = voters.filter(voter => voter.callStatus === statusFilter);
//     }

//     return voters;
//   }, [selectedType, getVotersByType, searchTerm, statusFilter]);

//   const getPaginatedVoters = useCallback(() => {
//     const filteredVoters = getFilteredVoters();
//     const startIndex = (currentPage - 1) * votersPerPage;
//     return filteredVoters.slice(startIndex, startIndex + votersPerPage);
//   }, [getFilteredVoters, currentPage, votersPerPage]);

//   const getTypeStatistics = useCallback(() => {
//     if (!selectedCampaign?.volterList) return {};

//     return voterTypes.reduce((stats, type) => {
//       const voters = getVotersByType(type.key);
//       stats[type.key] = {
//         total: voters.length,
//         notCalled: voters.filter(v => v.callStatus === 'not_called').length,
//         completed: voters.filter(v => v.callStatus === 'completed').length,
//         missed: voters.filter(v => v.callStatus === 'missed').length
//       };
//       return stats;
//     }, {});
//   }, [selectedCampaign, voterTypes, getVotersByType]);

//   // Selection Management
//   const toggleVoterSelection = useCallback((voterId) => {
//     setSelectedVoters(prev => {
//       const newSelection = new Set(prev);
//       if (newSelection.has(voterId)) {
//         newSelection.delete(voterId);
//       } else {
//         newSelection.add(voterId);
//       }
//       return newSelection;
//     });
//   }, []);

//   const toggleSelectAll = useCallback(() => {
//     const filteredVoters = getFilteredVoters();
//     const allSelected = filteredVoters.every(voter => selectedVoters.has(voter._id));

//     if (allSelected) {
//       setSelectedVoters(new Set());
//     } else {
//       setSelectedVoters(new Set(filteredVoters.map(v => v._id)));
//     }
//   }, [getFilteredVoters, selectedVoters]);

//   // Call Management
//   const handleBulkCall = useCallback(async (type = 'selected') => {
//     console.log('handleBulkCall called with type:', type);
//     const votersToCall = type === 'all'
//       ? getFilteredVoters()
//       : getFilteredVoters().filter(voter => selectedVoters.has(voter._id));

//     console.log('Voters to call:', votersToCall);

//     if (votersToCall.length === 0) {
//       showNotification('warning', 'No voters selected for calling');
//       return;
//     }

//     const agentId = selectedCampaign?.linkedPromptTemplate?.agentId;
//     const promptId = selectedCampaign?.linkedPromptTemplate?.promptID;
//     console.log('Agent ID:', agentId);
//     console.log('Prompt ID:', promptId);

//     if (!agentId) {
//       showNotification('error', 'No agent assigned to this campaign');
//       return;
//     }

//     const calls = votersToCall
//       .filter(voter => voter.voterContact)
//       .map(voter => ({
//         toNumber: voter.voterContact,
//         fromNumber: "+918035738038",
//         customerName: voter.voterName
//       }));

//     console.log('Calls array:', calls);

//     if (calls.length === 0) {
//       showNotification('warning', 'No voters with contact numbers selected');
//       return;
//     }

//     const payload = {
//       assignedAgentId: agentId,
//       promptId: promptId,
//       calls: calls
//     };

//     console.log('Sending payload:', payload);

//     try {
//       setLoading(true);
//       const token = localStorage.getItem('token');
//       console.log('Token exists:', !!token);

//       const response = await fetch('https://prod.toxboxai.com/api/election-call/initiate-call', {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(payload)
//       });

//       console.log('Response status:', response.status);
//       console.log('Response headers:', [...response.headers.entries()]);

//       const result = await parseSSE(response);
//       console.log('Parsed SSE Result:', result);

//       if (result.success) {
//         showNotification('success', `Initiated calls for ${calls.length} voters`);
//         if (type === 'selected') {
//           setSelectedVoters(new Set());
//         }
//         fetchCampaigns();
//       } else {
//         showNotification('error', result.error || 'Failed to initiate calls');
//       }
//     } catch (error) {
//       console.error('Error initiating calls:', error);
//       showNotification('error', 'Network error occurred');
//     } finally {
//       setLoading(false);
//     }
//   }, [getFilteredVoters, selectedVoters, showNotification, selectedCampaign, fetchCampaigns, parseSSE]);

//   // Computed Values
//   const typeStats = getTypeStatistics();
//   const filteredVoters = getFilteredVoters();
//   const paginatedVoters = getPaginatedVoters();
//   const totalPages = Math.ceil(filteredVoters.length / votersPerPage);
//   const isAllSelected = filteredVoters.length > 0 &&
//     filteredVoters.every(voter => selectedVoters.has(voter._id));

//   // Utility Functions
//   const formatNumber = (num) => new Intl.NumberFormat('en-IN').format(num);
//   const formatDate = (date) => new Date(date).toLocaleDateString('en-IN', {
//     year: 'numeric',
//     month: 'short',
//     day: 'numeric'
//   });

//   const getStatusBadge = (status) => {
//     const badges = {
//       not_called: { label: 'Not Called', class: styles.statusNotCalled },
//       completed: { label: 'Completed', class: styles.statusCompleted },
//       missed: { label: 'Missed', class: styles.statusMissed }
//     };

//     const badge = badges[status] || badges.not_called;
//     return <span className={`${styles.statusBadge} ${badge.class}`}>{badge.label}</span>;
//   };

//   return (
//     <div className={styles.campaignManager}>
//       {/* Notification */}
//       {notification.show && (
//         <div className={`${styles.notification} ${styles[notification.type]} ${styles.show}`}>
//           <div className={styles.notificationContent}>
//             <span className={styles.notificationIcon}>
//               {notification.type === 'success' && '✅'}
//               {notification.type === 'error' && '❌'}
//               {notification.type === 'warning' && '⚠️'}
//               {notification.type === 'info' && 'ℹ️'}
//             </span>
//             <span className={styles.notificationMessage}>{notification.message}</span>
//           </div>
//         </div>
//       )}

//       {/* Header */}
//       <header className={styles.header}>
//         <div className={styles.headerContent}>
//           <div className={styles.headerLeft}>
//             <h1 className={styles.title}>Election Campaign Manager</h1>
//             <p className={styles.subtitle}>Manage your electoral campaigns efficiently</p>
//           </div>
//           <div className={styles.headerRight}>
//             <button
//               className={styles.primaryButton}
//               onClick={() => setShowCreateForm(true)}
//               disabled={loading}
//             >
//               <span className={styles.buttonIcon}>+</span>
//               New Campaign
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* Main Content */}
//       <main className={styles.mainContent}>
//         {loading && campaigns.length === 0 ? (
//           <div className={styles.loadingState}>
//             <div className={styles.spinner}></div>
//             <p>Loading campaigns...</p>
//           </div>
//         ) : campaigns.length === 0 ? (
//           <div className={styles.emptyState}>
//             <div className={styles.emptyStateIcon}>🗳️</div>
//             <h2>No Campaigns Yet</h2>
//             <p>Create your first election campaign to get started</p>
//             <button
//               className={styles.primaryButton}
//               onClick={() => setShowCreateForm(true)}
//             >
//               Create First Campaign
//             </button>
//           </div>
//         ) : (
//           <div className={styles.campaignsGrid}>
//             {campaigns.map((campaign) => (
//               <div key={campaign._id} className={styles.campaignCard}>
//                 <div className={styles.cardHeader}>
//                   <div className={styles.cardHeaderLeft}>
//                     <h3 className={styles.cardTitle}>{campaign.leaderName}</h3>
//                     <span className={styles.partyBadge}>{campaign.partyName}</span>
//                   </div>
//                   <div className={styles.cardHeaderRight}>
//                     <span className={styles.voterCount}>
//                       {campaign.volterList?.length || 0} voters
//                     </span>
//                   </div>
//                 </div>

//                 <div className={styles.cardBody}>
//                   <div className={styles.cardInfo}>
//                     <p><strong>Address:</strong> {campaign.leaderAddress}</p>
//                     {campaign.Constituency && (
//                       <p><strong>Constituency:</strong> {campaign.Constituency}</p>
//                     )}
//                     {campaign.ConstituencyTotalVoters && (
//                       <div className={styles.coverageInfo}>
//                         <p><strong>Total Voters:</strong> {formatNumber(campaign.ConstituencyTotalVoters)}</p>
//                         <div className={styles.coverageProgress}>
//                           <div className={styles.progressBar}>
//                             <div
//                               className={styles.progressFill}
//                               style={{
//                                 width: `${Math.min((campaign.volterList?.length || 0) / campaign.ConstituencyTotalVoters * 100, 100)}%`
//                               }}
//                             ></div>
//                           </div>
//                           <span className={styles.coverageText}>
//                             {((campaign.volterList?.length || 0) / campaign.ConstituencyTotalVoters * 100).toFixed(1)}% coverage
//                           </span>
//                         </div>
//                       </div>
//                     )}
//                     <p><strong>Created:</strong> {formatDate(campaign.createdAt)}</p>
//                   </div>
//                 </div>

//                 <div className={styles.cardFooter}>
//                   <button
//                     className={styles.secondaryButton}
//                     onClick={() => openCampaignDetails(campaign)}
//                   >
//                     View Details
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </main>

//       {/* Create Campaign Modal */}
//       {showCreateForm && (
//         <div className={styles.modal}>
//           <div className={styles.modalOverlay} onClick={() => setShowCreateForm(false)}></div>
//           <div className={styles.modalContent}>
//             <div className={styles.modalHeader}>
//               <h2>Create New Campaign</h2>
//               <button
//                 className={styles.modalClose}
//                 onClick={() => setShowCreateForm(false)}
//               >
//                 ×
//               </button>
//             </div>

//             <form onSubmit={handleFormSubmit} className={styles.form}>
//               <div className={styles.formSection}>
//                 <h3 className={styles.sectionTitle}>Basic Information</h3>

//                 <div className={styles.formGrid}>
//                   <div className={styles.formGroup}>
//                     <label className={styles.label}>Leader Name *</label>
//                     <input
//                       type="text"
//                       name="leaderName"
//                       value={formData.leaderName}
//                       onChange={handleInputChange}
//                       className={`${styles.input} ${formErrors.leaderName ? styles.inputError : ''}`}
//                       placeholder="Enter leader name"
//                     />
//                     {formErrors.leaderName && (
//                       <span className={styles.errorText}>{formErrors.leaderName}</span>
//                     )}
//                   </div>

//                   <div className={styles.formGroup}>
//                     <label className={styles.label}>Party Name *</label>
//                     <input
//                       type="text"
//                       name="partyName"
//                       value={formData.partyName}
//                       onChange={handleInputChange}
//                       className={`${styles.input} ${formErrors.partyName ? styles.inputError : ''}`}
//                       placeholder="Enter party name"
//                     />
//                     {formErrors.partyName && (
//                       <span className={styles.errorText}>{formErrors.partyName}</span>
//                     )}
//                   </div>

//                   <div className={styles.formGroup}>
//                     <label className={styles.label}>Contact Number</label>
//                     <input
//                       type="tel"
//                       name="leaderContact"
//                       value={formData.leaderContact}
//                       onChange={handleInputChange}
//                       className={`${styles.input} ${formErrors.leaderContact ? styles.inputError : ''}`}
//                       placeholder="Enter contact number"
//                     />
//                     {formErrors.leaderContact && (
//                       <span className={styles.errorText}>{formErrors.leaderContact}</span>
//                     )}
//                   </div>

//                   <div className={styles.formGroup}>
//                     <label className={styles.label}>Email Address</label>
//                     <input
//                       type="email"
//                       name="leaderEmail"
//                       value={formData.leaderEmail}
//                       onChange={handleInputChange}
//                       className={`${styles.input} ${formErrors.leaderEmail ? styles.inputError : ''}`}
//                       placeholder="Enter email address"
//                     />
//                     {formErrors.leaderEmail && (
//                       <span className={styles.errorText}>{formErrors.leaderEmail}</span>
//                     )}
//                   </div>
//                 </div>

//                 <div className={styles.formGroup}>
//                   <label className={styles.label}>Address *</label>
//                   <textarea
//                     name="leaderAddress"
//                     value={formData.leaderAddress}
//                     onChange={handleInputChange}
//                     className={`${styles.textarea} ${formErrors.leaderAddress ? styles.inputError : ''}`}
//                     placeholder="Enter complete address"
//                     rows="3"
//                   />
//                   {formErrors.leaderAddress && (
//                     <span className={styles.errorText}>{formErrors.leaderAddress}</span>
//                   )}
//                 </div>
//               </div>

//               <div className={styles.formSection}>
//                 <h3 className={styles.sectionTitle}>Constituency Information</h3>

//                 <div className={styles.formGrid}>
//                   <div className={styles.formGroup}>
//                     <label className={styles.label}>Constituency</label>
//                     <input
//                       type="text"
//                       name="Constituency"
//                       value={formData.Constituency}
//                       onChange={handleInputChange}
//                       className={styles.input}
//                       placeholder="Enter constituency name"
//                     />
//                   </div>

//                   <div className={styles.formGroup}>
//                     <label className={styles.label}>Total Constituency Voters</label>
//                     <input
//                       type="text"
//                       name="ConstituencyTotalVoters"
//                       value={formData.ConstituencyTotalVoters}
//                       onChange={handleInputChange}
//                       className={`${styles.input} ${formErrors.ConstituencyTotalVoters ? styles.inputError : ''}`}
//                       placeholder="Enter total voters"
//                     />
//                     {formErrors.ConstituencyTotalVoters && (
//                       <span className={styles.errorText}>{formErrors.ConstituencyTotalVoters}</span>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               <div className={styles.formSection}>
//                 <h3 className={styles.sectionTitle}>Campaign Details</h3>

//                 <div className={styles.formGroup}>
//                   <label className={styles.label}>Manifesto</label>
//                   <textarea
//                     name="manifesto"
//                     value={formData.manifesto}
//                     onChange={handleInputChange}
//                     className={styles.textarea}
//                     placeholder="Enter campaign manifesto and promises"
//                     rows="4"
//                   />
//                 </div>

//                 <div className={styles.formGroup}>
//                   <label className={styles.label}>Voter Data Files *</label>
//                   <div className={styles.fileUpload}>
//                     <input
//                       type="file"
//                       multiple
//                       accept=".xlsx,.xls"
//                       onChange={handleFileChange}
//                       className={styles.fileInput}
//                       id="voter-files"
//                     />
//                     <label
//                       htmlFor="voter-files"
//                       className={`${styles.fileLabel} ${formErrors.files ? styles.inputError : ''}`}
//                     >
//                       <span className={styles.fileIcon}>📁</span>
//                       <span>Choose Excel files or drag and drop</span>
//                     </label>
//                   </div>
//                   {formErrors.files && (
//                     <span className={styles.errorText}>{formErrors.files}</span>
//                   )}

//                   {files.length > 0 && (
//                     <div className={styles.fileList}>
//                       {files.map((file, index) => (
//                         <div key={index} className={styles.fileItem}>
//                           <span className={styles.fileName}>📄 {file.name}</span>
//                           <span className={styles.fileSize}>
//                             {(file.size / 1024).toFixed(1)} KB
//                           </span>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </div>

//               <div className={styles.formActions}>
//                 <button
//                   type="button"
//                   className={styles.secondaryButton}
//                   onClick={() => setShowCreateForm(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className={styles.primaryButton}
//                   disabled={loading}
//                 >
//                   {loading ? (
//                     <>
//                       <span className={styles.spinner}></span>
//                       Creating...
//                     </>
//                   ) : (
//                     'Create Campaign'
//                   )}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Campaign Details Modal */}
//       {showCampaignDetails && selectedCampaign && (
//         <div className={`${styles.modal} ${isFullscreen ? styles.fullscreen : ''}`}>
//           <div className={styles.modalOverlay} onClick={closeCampaignDetails}></div>
//           <div className={styles.modalContent}>
//             <div className={styles.modalHeader}>
//               <div className={styles.modalHeaderLeft}>
//                 {selectedType && (
//                   <button
//                     className={styles.backButton}
//                     onClick={() => setSelectedType(null)}
//                   >
//                     ← Back
//                   </button>
//                 )}
//                 <div>
//                   <h2>
//                     {selectedType ? `${selectedType.label}` : selectedCampaign.leaderName}
//                   </h2>
//                   <span className={styles.partyBadge}>{selectedCampaign.partyName}</span>
//                 </div>
//               </div>
//               <div className={styles.modalHeaderRight}>
//                 <button
//                   className={styles.fullscreenButton}
//                   onClick={() => setIsFullscreen(!isFullscreen)}
//                 >
//                   {isFullscreen ? '⤢' : '⤡'}
//                 </button>
//                 <button
//                   className={styles.modalClose}
//                   onClick={closeCampaignDetails}
//                 >
//                   ×
//                 </button>
//               </div>
//             </div>

//             <div className={styles.modalBody}>
//               {!selectedType ? (
//                 // Campaign Overview
//                 <div className={styles.campaignOverview}>
//                   <div className={styles.campaignInfo}>
//                     <div className={styles.infoGrid}>
//                       <div className={styles.infoCard}>
//                         <h4>Contact Information</h4>
//                         <p><strong>Address:</strong> {selectedCampaign.leaderAddress}</p>
//                         {selectedCampaign.leaderContact && (
//                           <p><strong>Phone:</strong> {selectedCampaign.leaderContact}</p>
//                         )}
//                         {selectedCampaign.leaderEmail && (
//                           <p><strong>Email:</strong> {selectedCampaign.leaderEmail}</p>
//                         )}
//                       </div>

//                       <div className={styles.infoCard}>
//                         <h4>Constituency Details</h4>
//                         {selectedCampaign.Constituency ? (
//                           <p><strong>Constituency:</strong> {selectedCampaign.Constituency}</p>
//                         ) : (
//                           <p>No constituency information</p>
//                         )}
//                         {selectedCampaign.ConstituencyTotalVoters && (
//                           <>
//                             <p><strong>Total Voters:</strong> {formatNumber(selectedCampaign.ConstituencyTotalVoters)}</p>
//                             <div className={styles.coverageMetric}>
//                               <div className={styles.coverageBar}>
//                                 <div
//                                   className={styles.coverageFill}
//                                   style={{
//                                     width: `${Math.min((selectedCampaign.volterList?.length || 0) / selectedCampaign.ConstituencyTotalVoters * 100, 100)}%`
//                                   }}
//                                 ></div>
//                               </div>
//                               <span>
//                                 {((selectedCampaign.volterList?.length || 0) / selectedCampaign.ConstituencyTotalVoters * 100).toFixed(1)}% Coverage
//                               </span>
//                             </div>
//                           </>
//                         )}
//                       </div>

//                       <div className={styles.infoCard}>
//                         <h4>Campaign Stats</h4>
//                         <p><strong>Total Voters:</strong> {selectedCampaign.volterList?.length || 0}</p>
//                         <p><strong>Created:</strong> {formatDate(selectedCampaign.createdAt)}</p>
//                         <p><strong>Created by:</strong> {selectedCampaign.createdBy?.email || 'N/A'}</p>
//                       </div>
//                     </div>

//                     {selectedCampaign.manifesto && (
//                       <div className={styles.manifestoCard}>
//                         <h4>Campaign Manifesto</h4>
//                         <p>{selectedCampaign.manifesto}</p>
//                       </div>
//                     )}
//                   </div>

//                   <div className={styles.voterTypesSection}>
//                     <h3>Voter Categories</h3>
//                     <div className={styles.typeCards}>
//                       {voterTypes.map(type => {
//                         const stats = typeStats[type.key] || { total: 0, notCalled: 0, completed: 0, missed: 0 };
//                         return (
//                           <div
//                             key={type.key}
//                             className={styles.typeCard}
//                             onClick={() => selectVoterType(type)}
//                             style={{ backgroundColor: type.bgColor, borderColor: type.color }}
//                           >
//                             <div className={styles.typeCardHeader}>
//                               <div className={styles.typeCardIcon} style={{ color: type.color }}>
//                                 {type.icon}
//                               </div>
//                               <div className={styles.typeCardInfo}>
//                                 <h4>{type.label}</h4>
//                                 <p>{type.description}</p>
//                               </div>
//                               <div className={styles.typeCardCount} style={{ backgroundColor: type.color }}>
//                                 {stats.total}
//                               </div>
//                             </div>

//                             <div className={styles.typeCardStats}>
//                               <div className={styles.statItem}>
//                                 <span className={styles.statValue}>{stats.notCalled}</span>
//                                 <span className={styles.statLabel}>Not Called</span>
//                               </div>
//                               <div className={styles.statItem}>
//                                 <span className={styles.statValue}>{stats.completed}</span>
//                                 <span className={styles.statLabel}>Completed</span>
//                               </div>
//                               <div className={styles.statItem}>
//                                 <span className={styles.statValue}>{stats.missed}</span>
//                                 <span className={styles.statLabel}>Missed</span>
//                               </div>
//                             </div>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 // Voter List for Selected Type
//                 <div className={styles.voterManagement}>
//                   <div className={styles.voterControls}>
//                     <div className={styles.searchAndFilter}>
//                       <div className={styles.searchBox}>
//                         <input
//                           type="text"
//                           placeholder="Search voters..."
//                           value={searchTerm}
//                           onChange={(e) => {
//                             setSearchTerm(e.target.value);
//                             setCurrentPage(1);
//                           }}
//                           className={styles.searchInput}
//                         />
//                       </div>

//                       <select
//                         value={statusFilter}
//                         onChange={(e) => {
//                           setStatusFilter(e.target.value);
//                           setCurrentPage(1);
//                         }}
//                         className={styles.filterSelect}
//                       >
//                         <option value="all">All Status</option>
//                         <option value="not_called">Not Called</option>
//                         <option value="completed">Completed</option>
//                         <option value="missed">Missed</option>
//                       </select>
//                     </div>

//                     <div className={styles.bulkActions}>
//                       <button
//                         className={styles.secondaryButton}
//                         onClick={() => handleBulkCall('selected')}
//                         disabled={selectedVoters.size === 0 || loading}
//                       >
//                         📞 Call Selected ({selectedVoters.size})
//                       </button>
//                       <button
//                         className={styles.primaryButton}
//                         onClick={() => handleBulkCall('all')}
//                         disabled={filteredVoters.length === 0 || loading}
//                       >
//                         📞 Call All ({filteredVoters.length})
//                       </button>
//                     </div>
//                   </div>

//                   {filteredVoters.length > 0 ? (
//                     <>
//                       <div className={styles.voterTable}>
//                         <table>
//                           <thead>
//                             <tr>
//                               <th>
//                                 <input
//                                   type="checkbox"
//                                   checked={isAllSelected}
//                                   onChange={toggleSelectAll}
//                                 />
//                               </th>
//                               <th>Voter ID</th>
//                               <th>Name</th>
//                               <th>Contact</th>
//                               <th>Address</th>
//                               <th>Status</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {paginatedVoters.map((voter) => (
//                               <tr key={voter._id}>
//                                 <td>
//                                   <input
//                                     type="checkbox"
//                                     checked={selectedVoters.has(voter._id)}
//                                     onChange={() => toggleVoterSelection(voter._id)}
//                                   />
//                                 </td>
//                                 <td>{voter.voterId || 'N/A'}</td>
//                                 <td>{voter.voterName || 'N/A'}</td>
//                                 <td>{voter.voterContact || 'N/A'}</td>
//                                 <td className={styles.addressCell}>{voter.voterAddress || 'N/A'}</td>
//                                 <td>{getStatusBadge(voter.callStatus)}</td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>

//                       {totalPages > 1 && (
//                         <div className={styles.pagination}>
//                           <button
//                             onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//                             disabled={currentPage === 1}
//                             className={styles.paginationButton}
//                           >
//                             ← Previous
//                           </button>

//                           <div className={styles.pageNumbers}>
//                             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                               const page = Math.max(1, currentPage - 2) + i;
//                               if (page > totalPages) return null;

//                               return (
//                                 <button
//                                   key={page}
//                                   onClick={() => setCurrentPage(page)}
//                                   className={`${styles.pageNumber} ${currentPage === page ? styles.active : ''}`}
//                                 >
//                                   {page}
//                                 </button>
//                               );
//                             })}
//                           </div>

//                           <button
//                             onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
//                             disabled={currentPage === totalPages}
//                             className={styles.paginationButton}
//                           >
//                             Next →
//                           </button>
//                         </div>
//                       )}

//                       <div className={styles.tableFooter}>
//                         Showing {((currentPage - 1) * votersPerPage) + 1} to{' '}
//                         {Math.min(currentPage * votersPerPage, filteredVoters.length)} of{' '}
//                         {filteredVoters.length} voters
//                       </div>
//                     </>
//                   ) : (
//                     <div className={styles.emptyState}>
//                       <div className={styles.emptyStateIcon}>🔍</div>
//                       <h3>No voters found</h3>
//                       <p>Try adjusting your search or filter criteria</p>
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CampaignManager;
import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  FaPlus,
  FaTrash,
  FaCheckCircle,
  FaTimesCircle,
  FaExclamationTriangle,
  FaInfoCircle,
  FaVoteYea,
  FaSearch,
  FaQuestionCircle,
  FaHandshake,
  FaCrown,
  FaBuilding,
  FaStar,
  FaCog,
  // FaPhone,
  FaFolder,
  FaFileAlt,
  FaEdit,
  FaSpinner,
  FaDatabase,
  FaUpload,
  FaClock,
  FaEye,
  FaPhone,
  FaPhoneSlash,
} from "react-icons/fa";
import styles from "./Styles/CampaignManager.module.css";
import { FaStreetView } from "react-icons/fa6";
import { CiViewList } from "react-icons/ci";

const CampaignManager = () => {
  // State Management
  const [campaigns, setCampaigns] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedVoters, setSelectedVoters] = useState(new Set());
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showCampaignDetails, setShowCampaignDetails] = useState(false);
  const [loading, setLoading] = useState(false);
  const [campaignDetailsLoading, setCampaignDetailsLoading] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [voterPage, setVoterPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  // Enhanced Upload Progress State
  const [uploadProgress, setUploadProgress] = useState({
    isUploading: false,
    progress: 0,
    processedRecords: 0,
    totalRecords: 0,
    currentFile: "",
    speed: 0,
    stage: "", // NEW: Current processing stage
    message: "", // NEW: Current status message
    estimatedTime: 0, // NEW: Estimated time remaining
    startTime: null,
    duplicatesSkipped: 0, // NEW: Track duplicates
    errors: 0, // NEW: Track errors
    avgSpeed: "0 records/sec", // NEW: Average processing speed
  });

  const [formData, setFormData] = useState({
    leaderName: "",
    partyName: "",
    leaderAddress: "",
    leaderContact: "",
    leaderEmail: "",
    manifesto: "",
    Constituency: "",
    ConstituencyTotalVoters: "",
  });

  const [files, setFiles] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [notification, setNotification] = useState({
    show: false,
    type: "",
    message: "",
  });

  const votersPerPage = 5;

  // Call Management State
  const [callProgress, setCallProgress] = useState({
    isCalling: false,
    currentChunk: 0,
    totalChunks: 0,
    completedCalls: 0,
    totalCalls: 0,
    startTime: null,
    elapsedTime: 0,
    estimatedTimeLeft: 0,
    currentCallIndex: 0,
  });

  // Voter Types Configuration
  const voterTypes = useMemo(() => [
    {
      key: "query",
      label: "Query Agent",
      icon: FaQuestionCircle,
      color: "#3b82f6",
      bgColor: "#eff6ff",
      description: "Voters with questions and concerns",
    },
    {
      key: "promise",
      label: "Promised Agent",
      icon: FaHandshake,
      color: "#10b981",
      bgColor: "#f0fdf4",
      description: "Voters who have promised support",
    },
    {
      key: "leader",
      label: "Community Agent",
      icon: FaCrown,
      color: "#f59e0b",
      bgColor: "#fffbeb",
      description: "Influential community leaders",
    },
    {
      key: "party",
      label: "Party Agent",
      icon: FaBuilding,
      color: "#8b5cf6",
      bgColor: "#faf5ff",
      description: "Registered party members",
    },
    {
      key: "influencer",
      label: "Influencers Agent",
      icon: FaStar,
      color: "#ef4444",
      bgColor: "#fef2f2",
      description: "Social media influencers",
    },
    {
      key: "custom",
      label: "Custom Agent",
      icon: FaCog,
      color: "#6b7280",
      bgColor: "#f9fafb",
      description: "Custom voter category",
    },
  ], []);

  // Effects
  useEffect(() => {
    console.log("Component mounted, fetching campaigns");
    fetchCampaigns();
  }, []);

  useEffect(() => {
    let interval;
    if (callProgress.isCalling) {
      interval = setInterval(() => {
        setCallProgress((prev) => {
          const elapsed = Math.floor((Date.now() - prev.startTime) / 1000);
          const avgTimePerCall = elapsed / prev.completedCalls || 0;
          const remainingCalls = prev.totalCalls - prev.completedCalls;
          const estimatedLeft = Math.round(avgTimePerCall * remainingCalls);
          return {
            ...prev,
            elapsedTime: elapsed,
            estimatedTimeLeft: estimatedLeft,
          };
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [callProgress.isCalling]);

  // NEW: Upload Progress Timer Effect
  useEffect(() => {
    let interval;
    if (uploadProgress.isUploading && uploadProgress.startTime) {
      interval = setInterval(() => {
        setUploadProgress((prev) => {
          const elapsed = Math.floor((Date.now() - prev.startTime) / 1000);
          const recordsPerSecond = prev.processedRecords / elapsed || 0;
          const remainingRecords = prev.totalRecords - prev.processedRecords;
          const estimatedTime = Math.round(remainingRecords / recordsPerSecond);
          return {
            ...prev,
            estimatedTime: isFinite(estimatedTime) ? estimatedTime : 0,
            avgSpeed: `${recordsPerSecond.toFixed(1)} records/sec`,
          };
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [uploadProgress.isUploading, uploadProgress.startTime]);

  // Notification Handler
  const showNotification = useCallback((type, message) => {
    console.log(`Showing notification: ${type} - ${message}`);
    setNotification({ show: true, type, message });
    setTimeout(() => {
      setNotification({ show: false, type: "", message: "" });
    }, 4000);
  }, []);

  // API Functions
  const fetchCampaigns = useCallback(async () => {
    console.log("Fetching campaigns...");
    try {
      const creatorId = localStorage.getItem("userId");
      console.log("Creator ID:", creatorId);

      if (!creatorId) {
        const error = new Error("No creator ID found in localStorage");
        console.error("Fetch Campaigns Error:", error);
        showNotification("error", error.message);
        return;
      }

      setLoading(true);
      const token = localStorage.getItem("token");
      console.log("Token for fetch:", !!token);

      const response = await fetch(
        `https://prod.toxboxai.com/api/election-campaign/by-creator/${creatorId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Fetch response status:", response.status);

      if (!response.ok) {
        const error = new Error(`HTTP error! status: ${response.status}`);
        console.error("Fetch HTTP Error:", error);
        showNotification("error", error.message);
        return;
      }

      const result = await response.json();
      console.log("Fetch result:", result);

      if (result.success) {
        console.log("Campaigns fetched successfully:", result.data);
        setCampaigns(result.data);
      } else {
        console.log("Fetch failed:", result.error);
        showNotification("error", result.error || "Failed to fetch campaigns");
      }
    } catch (error) {
      console.error("Error fetching campaigns:", error);
      showNotification("error", error.message || "Network error occurred");
    } finally {
      setLoading(false);
      console.log("Fetch campaigns complete");
    }
  }, [showNotification]);

  // NEW: Fetch specific campaign with voters
  const fetchCampaignDetails = useCallback(async (campaignId, voterPageNum = 1) => {
    console.log(`Fetching campaign details for ${campaignId}, voter page ${voterPageNum}`);
    try {
      const creatorId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");

      if (!creatorId || !token) {
        showNotification("error", "Authentication required");
        return;
      }

      setCampaignDetailsLoading(true);

      const response = await fetch(
        `https://prod.toxboxai.com/api/election-campaign/by-creator/${creatorId}?campaignId=${campaignId}&voterPage=${voterPageNum}&voterLimit=${votersPerPage}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log("Campaign details result:", result);

      if (result.success && result.data.length > 0) {
        const campaignWithVoters = result.data[0];
        console.log("Campaign with voters fetched:", campaignWithVoters);

        // Update the selected campaign with voter details
        setSelectedCampaign(prev => ({
          ...prev,
          ...campaignWithVoters,
          voterPagination: campaignWithVoters.voterPagination
        }));

        setVoterPage(voterPageNum);
      } else {
        showNotification("error", "Campaign not found");
      }
    } catch (error) {
      console.error("Error fetching campaign details:", error);
      showNotification("error", error.message);
    } finally {
      setCampaignDetailsLoading(false);
    }
  }, [showNotification, votersPerPage]);

  const [openHistoryId, setOpenHistoryId] = useState(null);

  function getCallHistory(voter) {
    if (!Array.isArray(voter.prompts)) return [];

    const typeKey = selectedType?.key || null;

    return voter.prompts
      .flatMap(prompt =>
        Array.isArray(prompt.joined)
          ? prompt.joined
            .filter(call => !typeKey || call.type === typeKey)
            .map(call => ({
              type: `${call.type}`,
              status: call.voterCallStatus,
              date: call.callDateTime,
              duration: call.callDuration !== undefined
                ? typeof call.callDuration === 'number'
                  ? `${Number(call.callDuration).toFixed(0)}s`
                  : `${call.callDuration}s`
                : '-',
              summary: call.summary
            }))
          : []
      );
  }





  // Popup-specific status with icons (only for call history)
  const getCallHistoryStatusIcon = (status) => {
    if (status === 'completed') {
      return (
        <span className="historyStatusCompleted">
          <FaPhone className="historyCallIcon" title="Completed Call" />
          {/* <span className="historyStatusText">Completed</span> */}
        </span>
      );
    }

    if (status === 'missed') {
      return (
        <span className="historyStatusMissed">
          <FaPhoneSlash className="historyMissedIcon" title="Missed Call" />
          {/* <span className="historyStatusText">Missed</span> */}
        </span>
      );
    }

    // Default text for not_called or other statuses
    return (
      <span className="historyStatusNotCalled">
        <span className="historyStatusText">Not Called</span>
      </span>
    );
  };

  // Form Validation
  const validateForm = useCallback(() => {
    console.log("Validating form...");
    const errors = {};
    if (!formData.leaderName.trim())
      errors.leaderName = "Leader name is required";
    if (!formData.partyName.trim()) errors.partyName = "Party name is required";
    if (!showEditForm && !formData.leaderAddress.trim())
      errors.leaderAddress = "Address is required";
    if (
      formData.leaderContact &&
      !/^\+?[\d\s-()]+$/.test(formData.leaderContact)
    ) {
      errors.leaderContact = "Invalid contact number";
    }
    if (formData.leaderEmail && !/\S+@\S+\.\S+/.test(formData.leaderEmail)) {
      errors.leaderEmail = "Invalid email address";
    }
    if (
      formData.ConstituencyTotalVoters &&
      (isNaN(formData.ConstituencyTotalVoters) ||
        parseInt(formData.ConstituencyTotalVoters) <= 0)
    ) {
      errors.ConstituencyTotalVoters = "Must be a positive number";
    }
    if (!showEditForm && files.length === 0)
      errors.files = "At least one Excel file is required";
    console.log("Form errors:", errors);
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  }, [formData, files, showEditForm]);

  // Form Handlers
  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    console.log(`Input change: ${name} = ${value}`);
    if (name === "ConstituencyTotalVoters") {
      const numericValue = value.replace(/[^0-9]/g, "");
      setFormData((prev) => ({ ...prev, [name]: numericValue }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
    if (formErrors[name]) {
      console.log(`Clearing error for ${name}`);
      setFormErrors((prev) => ({ ...prev, [name]: "" }));
    }
  }, [formErrors]);

  const handleFileChange = useCallback((e) => {
    const selectedFiles = Array.from(e.target.files);
    console.log("Files selected:", selectedFiles.map((f) => f.name));
    setFiles(selectedFiles);
    if (formErrors.files) {
      console.log("Clearing files error");
      setFormErrors((prev) => ({ ...prev, files: "" }));
    }
  }, [formErrors]);

  const handleDiscardFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const resetForm = useCallback(() => {
    console.log("Resetting form...");
    setFormData({
      leaderName: "",
      partyName: "",
      leaderAddress: "",
      leaderContact: "",
      leaderEmail: "",
      manifesto: "",
      Constituency: "",
      ConstituencyTotalVoters: "",
    });
    setFiles([]);
    setFormErrors({});
  }, []);

  // NEW: Enhanced Form Submit with SSE Progress Tracking
  const handleFormSubmit = useCallback(async (e) => {
    e.preventDefault();
    console.log("Form submit triggered");
    if (!validateForm()) {
      console.log("Form validation failed");
      return;
    }
    console.log("Form validation passed, submitting...");

    // Initialize upload progress
    setUploadProgress({
      isUploading: true,
      progress: 0,
      processedRecords: 0,
      totalRecords: 0,
      currentFile: files[0]?.name || "Processing...",
      speed: 0,
      stage: "Initializing",
      message: "Preparing to upload campaign data...",
      estimatedTime: 0,
      startTime: Date.now(),
      duplicatesSkipped: 0,
      errors: 0,
      avgSpeed: "0 records/sec",
    });

    setLoading(true);

    const formDataToSend = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (value.trim()) {
        formDataToSend.append(key, formData[key]);
        console.log(`Appending form data: ${key} = ${formData[key]}`);
      }
    });
    files.forEach((file, index) => {
      formDataToSend.append("files", file);
      console.log(`Appending file ${index}: ${file.name}`);
    });

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("No authentication token found");
      }

      console.log("Submitting to API with SSE...");

      // Start SSE connection for progress updates
      const eventSource = new EventSource(
        `https://prod.toxboxai.com/api/election-campaign/progress?token=${encodeURIComponent(token)}`
      );

      // Handle SSE events
      eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          console.log("SSE Progress Update:", data);

          setUploadProgress(prev => ({
            ...prev,
            progress: data.progress || prev.progress,
            processedRecords: data.processedRecords || prev.processedRecords,
            totalRecords: data.totalRecords || prev.totalRecords,
            currentFile: data.currentFile || prev.currentFile,
            stage: data.stage || prev.stage,
            message: data.message || prev.message,
            duplicatesSkipped: data.duplicatesSkipped || prev.duplicatesSkipped,
            errors: data.errors || prev.errors,
          }));

          // If upload is complete, close SSE
          if (data.stage === "completed" || data.progress === 100) {
            eventSource.close();
          }
        } catch (parseError) {
          console.error("Error parsing SSE data:", parseError);
        }
      };

      eventSource.onerror = (error) => {
        console.error("SSE Error:", error);
        eventSource.close();
      };

      // Submit the form
      const response = await fetch(
        "https://prod.toxboxai.com/api/election-campaign",
        {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formDataToSend,
        }
      );

      console.log("Form submit response status:", response.status);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log("Form submit result:", result);

      if (result.success) {
        console.log("Campaign created successfully");

        // Update final progress state
        setUploadProgress(prev => ({
          ...prev,
          isUploading: false,
          progress: 100,
          stage: "completed",
          message: "Campaign created successfully!",
          processedRecords: result.data?.votersProcessed || prev.processedRecords,
        }));

        showNotification(
          "success",
          result.data?.message || "Campaign created successfully"
        );

        // Show detailed success alert
        //         setTimeout(() => {
        //           alert(`Campaign created successfully! 

        // 📊 Performance Summary:
        // • Records Processed: ${result.data?.votersProcessed || 'N/A'}
        // • Processing Time: ${result.data?.processingTime || 'N/A'}
        // • Average Speed: ${result.data?.averageSpeed || 'N/A'}
        // • Duplicates Skipped: ${result.data?.duplicatesSkipped || 'N/A'}
        //           `);
        //         }, 1000);

        setShowCreateForm(false);
        resetForm();
        fetchCampaigns();

        // Reset upload progress after delay
        setTimeout(() => {
          setUploadProgress({
            isUploading: false,
            progress: 0,
            processedRecords: 0,
            totalRecords: 0,
            currentFile: "",
            speed: 0,
            stage: "",
            message: "",
            estimatedTime: 0,
            startTime: null,
            duplicatesSkipped: 0,
            errors: 0,
            avgSpeed: "0 records/sec",
          });
        }, 3000);

      } else {
        console.log("Campaign creation failed:", result.error);
        setUploadProgress(prev => ({
          ...prev,
          isUploading: false,
          stage: "error",
          message: result.error || "Failed to create campaign",
        }));
        showNotification(
          "error",
          result.error || "Failed to create campaign"
        );
      }

      // Close SSE connection
      eventSource.close();

    } catch (error) {
      console.error("Error creating campaign:", error);
      setUploadProgress(prev => ({
        ...prev,
        isUploading: false,
        stage: "error",
        message: error.message || "Failed to create campaign",
      }));
      showNotification("error", error.message || "Failed to create campaign");
    } finally {
      setLoading(false);
      console.log("Form submit complete");
    }
  }, [formData, files, validateForm, fetchCampaigns, showNotification]);

  // Rest of your existing methods (updateCampaign, deleteCampaign, etc.)
  const updateCampaign = useCallback(async (campaignId) => {
    console.log("Updating campaign:", campaignId);
    if (!validateForm()) {
      console.log("Form validation failed");
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        const error = new Error("No authentication token found");
        console.error("Update Campaign Error:", error);
        showNotification("error", error.message);
        return;
      }
      const payload = {
        leaderName: formData.leaderName.trim(),
        partyName: formData.partyName.trim(),
        leaderContact: formData.leaderContact.trim(),
        manifesto: formData.manifesto.trim(),
      };
      console.log("Update payload:", payload);
      const response = await fetch(
        `https://prod.toxboxai.com/api/campaign/${campaignId}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      console.log("Update response status:", response.status);
      if (!response.ok) {
        const error = new Error(`HTTP error! status: ${response.status}`);
        console.error("Update HTTP Error:", error);
        showNotification("error", error.message);
        return;
      }
      const result = await response.json();
      console.log("Update result:", result);
      if (result.success) {
        console.log("Campaign updated successfully");
        showNotification(
          "success",
          result.data?.message || "Campaign updated successfully"
        );
        setShowEditForm(false);
        resetForm();
        fetchCampaigns();
      } else {
        console.log("Update failed:", result.error);
        showNotification(
          "error",
          result.error || "Failed to update campaign"
        );
      }
    } catch (error) {
      console.error("Error updating campaign:", error);
      showNotification("error", error.message || "Failed to update campaign");
    } finally {
      setLoading(false);
      console.log("Update campaign complete");
    }
  }, [formData, validateForm, showNotification, fetchCampaigns]);

  const deleteCampaign = useCallback(async (campaignId) => {
    console.log("Deleting campaign:", campaignId);
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        const error = new Error("No authentication token found");
        console.error("Delete Campaign Error:", error);
        showNotification("error", error.message);
        return;
      }
      const response = await fetch(
        `https://prod.toxboxai.com/api/election-campaign/${campaignId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Delete response status:", response.status);
      if (!response.ok) {
        const error = new Error(`HTTP error! status: ${response.status}`);
        console.error("Delete HTTP Error:", error);
        showNotification("error", error.message);
        return;
      }
      const result = await response.json();
      console.log("Delete result:", result);
      if (result.success) {
        console.log("Campaign deleted successfully");
        showNotification(
          "success",
          result.data?.message || "Campaign deleted successfully"
        );
        setShowCampaignDetails(false);
        setSelectedCampaign(null);
        fetchCampaigns();
      } else {
        console.log("Delete failed:", result.error);
        showNotification(
          "error",
          result.error || "Failed to delete campaign"
        );
      }
    } catch (error) {
      console.error("Error deleting campaign:", error);
      showNotification("error", error.message || "Failed to delete campaign");
    } finally {
      setLoading(false);
      console.log("Delete campaign complete");
    }
  }, [showNotification, fetchCampaigns]);

  // Campaign Management Functions
  const openCampaignDetails = useCallback((campaign) => {
    console.log("Opening campaign details for:", campaign._id);
    setSelectedCampaign(campaign);
    setShowCampaignDetails(true);
    setSelectedType(null);
    setSelectedVoters(new Set());
    setVoterPage(1);
    setSearchTerm("");
    setStatusFilter("all");

    if (campaign.assignCredit === 0) {
      showNotification("warning", "Campaign balance is zero. You cannot initiate calls.");
    }
  }, [showNotification]);

  const closeCampaignDetails = useCallback(() => {
    console.log("Closing campaign details");
    setShowCampaignDetails(false);
    setSelectedCampaign(null);
    setSelectedType(null);
    setSelectedVoters(new Set());
    setVoterPage(1);
    setSearchTerm("");
    setStatusFilter("all");
    setOpenHistoryId(null);
  }, []);

  const openEditForm = useCallback((campaign) => {
    console.log("Opening edit form for campaign:", campaign._id);
    setSelectedCampaign(campaign);
    setFormData({
      leaderName: campaign.leaderName || "",
      partyName: campaign.partyName || "",
      leaderAddress: campaign.leaderAddress || "",
      leaderContact: campaign.leaderContact || "",
      leaderEmail: campaign.leaderEmail || "",
      manifesto: campaign.manifesto || "",
      Constituency: campaign.Constituency || "",
      ConstituencyTotalVoters: campaign.ConstituencyTotalVoters || "",
    });
    setShowEditForm(true);
  }, []);

  const handleEditFormSubmit = useCallback(async (e) => {
    e.preventDefault();
    if (!selectedCampaign) return;
    await updateCampaign(selectedCampaign._id);
  }, [selectedCampaign, updateCampaign]);

  // Handle voter type selection and load voters
  const selectVoterType = useCallback((type) => {
    console.log("Selecting voter type:", type.key);
    setSelectedType(type);
    setSelectedVoters(new Set());
    setCurrentPage(1);
    setSearchTerm("");
    setVoterPage(1);
    setOpenHistoryId(null);
    // If campaign doesn't have voter details, fetch them
    if (selectedCampaign && !selectedCampaign.volterList) {
      fetchCampaignDetails(selectedCampaign._id, 1);
    }
  }, [selectedCampaign, fetchCampaignDetails]);

  // Handle voter page navigation
  const handleVoterPageChange = useCallback((newPage) => {
    if (selectedCampaign && selectedType) {
      setVoterPage(newPage);
      fetchCampaignDetails(selectedCampaign._id, newPage);
    }
  }, [selectedCampaign, selectedType, fetchCampaignDetails]);

  // Get type statistics from API response or calculate from voter data
  const getTypeStatistics = useCallback(() => {
    console.log("Calculating type statistics...");
    if (!selectedCampaign) {
      console.log("No selected campaign for stats");
      return {};
    }

    // Use the voterTypeCounts from API response if available (initial load)
    if (selectedCampaign.voterTypeCounts) {
      console.log("Using API-provided voter type counts:", selectedCampaign.voterTypeCounts);

      // Transform API response to match expected format
      const transformedStats = {};
      Object.keys(selectedCampaign.voterTypeCounts).forEach(typeKey => {
        const apiStats = selectedCampaign.voterTypeCounts[typeKey];
        transformedStats[typeKey] = {
          total: apiStats.total || 0,
          notCalled: apiStats.notCalled || apiStats.not_called || 0,
          completed: apiStats.completed || 0,
          missed: apiStats.missed || 0,
        };
      });

      return transformedStats;
    }

    // Fallback to client-side calculation for specific campaign view with voter details
    if (!selectedCampaign?.volterList) {
      console.log("No volterList for stats");
      return {};
    }

    const allVoters = selectedCampaign.volterList;
    const stats = voterTypes.reduce((acc, type) => {
      let voters = allVoters.filter((voter) => {
        // Direct type match
        if (voter.type === type.key) return true;

        // SubType match
        if (voter.subType && Array.isArray(voter.subType) && voter.subType.includes(type.key)) {
          return true;
        }

        return false;
      });

      // Special filter for 'promise': Only completed query calls
      if (type.key === "promise") {
        voters = voters.filter((voter) => voter.callStatus?.query === "completed");
      }

      let notCalled = 0;
      let completed = 0;
      let missed = 0;

      voters.forEach((voter) => {
        const status = voter.callStatus?.[type.key] || "not_called";
        if (status === "not_called") notCalled++;
        else if (status === "completed") completed++;
        else if (status === "missed") missed++;
      });

      acc[type.key] = {
        total: voters.length,
        notCalled,
        completed,
        missed,
      };

      console.log(`Stats for ${type.key}:`, acc[type.key]);
      return acc;
    }, {});

    console.log("Calculated type stats:", stats);
    return stats;
  }, [selectedCampaign, voterTypes]);

  // Get voters by type (only works when voter details are loaded)
  const getVotersByType = useCallback((type) => {
    console.log("Getting voters by type:", type);
    if (!selectedCampaign?.volterList) {
      console.log("No volterList found");
      return [];
    }

    let voters = selectedCampaign.volterList.filter((voter) => {
      // Direct type match
      if (voter.type === type) return true;

      // SubType match for base types (query/promise)
      if ((voter.type === "query" || voter.type === "promise") &&
        voter.subType && Array.isArray(voter.subType) &&
        voter.subType.includes(type)) {
        return true;
      }

      return false;
    });

    // Special filter for 'promise': Only completed query calls
    if (type === "promise") {
      voters = voters.filter((voter) => voter.callStatus?.query === "completed");
      console.log(`Filtered ${voters.length} promise voters with query callStatus completed`);
    }

    console.log(`Found ${voters.length} voters for type ${type}`);
    return voters;
  }, [selectedCampaign]);

  // Get filtered voters with search and status filters
  const getFilteredVoters = useCallback(() => {
    console.log("Getting filtered voters...");
    if (!selectedType) {
      console.log("No selected type");
      return [];
    }

    let voters = getVotersByType(selectedType.key);

    if (searchTerm) {
      console.log("Applying search filter:", searchTerm);
      const search = searchTerm.toLowerCase();
      voters = voters.filter(voter =>
        voter.voterName?.toLowerCase().includes(search) ||
        voter.voterId?.toLowerCase().includes(search) ||
        voter.voterContact?.toLowerCase().includes(search) ||
        voter.voterAddress?.toLowerCase().includes(search)
      );
    }

    if (statusFilter !== "all") {
      console.log("Applying status filter:", statusFilter);
      voters = voters.filter(voter => {
        const typeStatus = voter.callStatus?.[selectedType.key] || "not_called";
        return typeStatus === statusFilter;
      });
    }

    console.log("Filtered voters count:", voters.length);
    return voters;
  }, [selectedType, getVotersByType, searchTerm, statusFilter]);

  // Get paginated voters (client-side pagination for filtered results)
  const getPaginatedVoters = useCallback(() => {
    const filteredVoters = getFilteredVoters();
    const startIndex = (currentPage - 1) * votersPerPage;
    const paginated = filteredVoters.slice(startIndex, startIndex + votersPerPage);
    console.log(`Paginated voters: page ${currentPage}, showing ${paginated.length}`);
    return paginated;
  }, [getFilteredVoters, currentPage, votersPerPage]);

  // Selection Management
  const toggleVoterSelection = useCallback((voterId) => {
    console.log("Toggling selection for voter:", voterId);
    setSelectedVoters((prev) => {
      const newSelection = new Set(prev);
      const campaignBalance = selectedCampaign?.assignCredit || 0;
      if (newSelection.has(voterId)) {
        newSelection.delete(voterId);
        console.log("Deselected voter:", voterId);
      } else {
        if (newSelection.size >= campaignBalance) {
          showNotification(
            "warning",
            `Cannot select more voters: Balance is too low. Maximum ${campaignBalance} voters can be selected.`
          );
          return prev;
        }
        newSelection.add(voterId);
        console.log("Selected voter:", voterId);
      }
      console.log("New selection size:", newSelection.size);
      return newSelection;
    });
  }, [selectedCampaign, showNotification]);

  const toggleSelectAll = useCallback(() => {
    const filteredVoters = getFilteredVoters();
    const campaignBalance = selectedCampaign?.assignCredit || 0;
    const allSelected = filteredVoters.every((voter) =>
      selectedVoters.has(voter._id)
    );
    console.log(
      "Toggle select all: allSelected?",
      allSelected,
      "filtered count:",
      filteredVoters.length
    );
    if (allSelected) {
      setSelectedVoters(new Set());
      console.log("Deselected all");
    } else {
      if (filteredVoters.length > campaignBalance) {
        showNotification(
          "warning",
          `Cannot select all voters: Balance is too low. Maximum ${campaignBalance} voters can be selected.`
        );
        return;
      }
      setSelectedVoters(new Set(filteredVoters.map((v) => v._id)));
      console.log("Selected all");
    }
  }, [getFilteredVoters, selectedVoters, selectedCampaign, showNotification]);

  const handleBulkCall = useCallback(
    async (type = "selected") => {
      console.log("handleBulkCall called with type:", type);

      // Guard - Bulk calls require selectedType
      if (!selectedType) {
        showNotification(
          "error",
          "Please select a voter type before initiating calls"
        );
        return;
      }
      const typeKey = selectedType.key; // e.g., 'influencer'
      console.log("Using selected type key for agents:", typeKey);

      const campaignBalance = selectedCampaign?.assignCredit || 0;
      console.log("Campaign balance:", campaignBalance);
      if (campaignBalance === 0) {
        showNotification(
          "warning",
          "Cannot initiate calls: Campaign balance is zero"
        );
        return;
      }
      const votersToCall =
        type === "all"
          ? getFilteredVoters()
          : getFilteredVoters().filter((voter) =>
            selectedVoters.has(voter._id)
          );
      console.log("Voters to call:", votersToCall.length);
      if (votersToCall.length === 0) {
        showNotification("warning", "No voters selected for calling");
        return;
      }
      if (votersToCall.length > campaignBalance) {
        showNotification(
          "warning",
          `Cannot initiate ${votersToCall.length} calls: Only ${campaignBalance} calls available based on your balance`
        );
        return;
      }
      const validVoters = votersToCall.filter((voter) => {
        let contact = voter.voterContact;
        if (contact && !contact.startsWith("+")) {
          contact = "+" + contact.replace(/[\s-]/g, "");
        }
        if (!contact || !contact.trim()) return false;
        if (!/^\+\d{10,15}$/.test(contact)) return false;

        // Early check for matching template
        const templates = voter.linkedPromptTemplate || [];
        const matchingTemplate = templates.find((t) => t.type === typeKey);
        if (!matchingTemplate?.agentId) return false;

        if (!voter._id || !voter.type) return false;
        return true;
      });
      console.log("Valid Voters:", validVoters.length);
      if (validVoters.length === 0) {
        showNotification(
          "warning",
          `No valid voters with contact numbers and matching agents selected for "${selectedType.label}"`
        );
        return;
      }
      const firstVoter = validVoters[0];
      const firstTemplates = firstVoter.linkedPromptTemplate || [];
      const firstMatchingTemplate = firstTemplates.find(
        (t) => t.type === typeKey
      );
      const agentId = firstMatchingTemplate?.agentId;
      if (!agentId) {
        showNotification(
          "error",
          `No agent created for selected "${selectedType.label}" category`
        );
        return;
      }
      console.log("Using agentId:", agentId);
      const CHUNK_SIZE = 50;
      const chunks = [];
      for (let i = 0; i < validVoters.length; i += CHUNK_SIZE) {
        chunks.push(validVoters.slice(i, i + CHUNK_SIZE));
      }
      setCallProgress({
        isCalling: true,
        currentChunk: 1,
        totalChunks: chunks.length,
        completedCalls: 0,
        totalCalls: validVoters.length,
        startTime: Date.now(),
        elapsedTime: 0,
        estimatedTimeLeft: 0,
        currentCallIndex: 0,
      });
      setLoading(true);
      try {
        let totalCompleted = 0;
        let expectedCallIndex = 1;
        for (let chunkIndex = 0; chunkIndex < chunks.length; chunkIndex++) {
          const chunk = chunks[chunkIndex];
          setCallProgress((prev) => ({
            ...prev,
            currentChunk: chunkIndex + 1,
          }));
          const calls = chunk.map((voter) => {
            const cleanPhoneNumber = (phone) => phone.replace(/[+\s-()]/g, "");

            // Per-call promptId matching selectedType.key
            const voterTemplates = voter.linkedPromptTemplate || [];
            const matchingTemplate = voterTemplates.find(
              (t) => t.type === typeKey
            );
            const promptId = matchingTemplate?.promptID || "";

            let callPayload = {
              toNumber: cleanPhoneNumber(voter.voterContact),
              fromNumber: "8035738038",
              customerName: voter.voterName || "Unknown",
              voterId: voter._id,
              promptId,
              campaignId: selectedCampaign._id,
              leaderName: selectedCampaign.leaderName,
              partyName: selectedCampaign.partyName,
              manifesto: selectedCampaign.manifesto?.trim() || "",
              Constituency: selectedCampaign.Constituency,
              ConstituencyTotalVoters: selectedCampaign.ConstituencyTotalVoters,
            };

            const isSubTypeMatch =
              voter.subType &&
              Array.isArray(voter.subType) &&
              voter.subType.includes(typeKey);
            const isDirectMatch = voter.type === typeKey;

            if (isSubTypeMatch) {
              callPayload.subtype = typeKey; // e.g., "subtype": "influencer"
              console.log(
                `Voter ${voter.voterName} subType match: subtype="${callPayload.subtype}" (raw type: ${voter.type})`
              );
            } else {
              callPayload.type = voter.type; // e.g., "type": "query"
              console.log(
                `Voter ${voter.voterName} direct match: type="${callPayload.type}"`
              );
            }

            return callPayload;
          });
          const payload = {
            assignedAgentId: agentId,
            calls,
            campaignId: selectedCampaign._id,
          };
          console.log(
            `Sending chunk ${chunkIndex + 1}/${chunks.length} with ${calls.length
            } calls`
          );
          const token = localStorage.getItem("token");
          if (!token) {
            throw new Error("No authentication token found");
          }
          const response = await fetch(
            "https://prod.toxboxai.com/api/election-call/initiate-call",
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            }
          );
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const processSSEStream = async (response) => {
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = "";
            try {
              while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, { stream: true });
                const events = buffer.split("\n\n");
                buffer = events.pop() || "";
                for (const eventStr of events) {
                  if (!eventStr.trim()) continue;
                  const lines = eventStr.split("\n");
                  let eventType = "message";
                  let dataStr = "";
                  for (const line of lines) {
                    if (line.startsWith("event: ")) {
                      eventType = line.slice(7).trim();
                    } else if (line.startsWith("data: ")) {
                      dataStr += line.slice(6).trim() + "\n";
                    } else if (line.startsWith(":")) {
                      continue;
                    }
                  }
                  if (dataStr.trim()) {
                    try {
                      const data = JSON.parse(dataStr.trim());
                      console.log(`SSE Event: ${eventType}`, data);

                      // Catch backend errors like "agent not found"
                      if (data.error) {
                        console.error("SSE Error Event:", data.error);
                        showNotification("error", data.error);
                        throw new Error(data.error);
                      }

                      if (
                        eventType === "status" &&
                        data.status === "completed"
                      ) {
                        if (
                          data.callIndex &&
                          data.callIndex === expectedCallIndex
                        ) {
                          totalCompleted++;
                          expectedCallIndex++;
                          // eslint-disable-next-line no-loop-func
                          setCallProgress((prev) => ({
                            ...prev,
                            completedCalls: totalCompleted,
                            currentCallIndex: data.callIndex,
                          }));
                          console.log(
                            `Call ${data.callIndex} completed. Total: ${totalCompleted}/${validVoters.length}`
                          );
                        }
                      } else if (eventType === "creditDeduction") {
                        console.log("Credit deducted:", data);
                      } else if (data.status === "processing") {
                        console.log("Call processing:", data.message);
                      }
                      if (data.savedData && data.savedData.voterId) {
                        console.log(
                          "Voter data updated:",
                          data.savedData.summary
                        );
                      }
                    } catch (parseError) {
                      console.error(
                        "Error parsing SSE data:",
                        parseError,
                        dataStr
                      );
                    }
                  }
                }
              }
            } catch (error) {
              console.error("SSE Stream Error:", error);
            } finally {
              reader.releaseLock();
            }
          };
          await processSSEStream(response);
          console.log(
            `Chunk ${chunkIndex + 1
            } completed. Total completed: ${totalCompleted}`
          );
          if (chunkIndex < chunks.length - 1) {
            await new Promise((resolve) => setTimeout(resolve, 2000));
          }
        }
        showNotification(
          "success",
          `Successfully initiated ${totalCompleted} calls out of ${validVoters.length}`
        );
        if (type === "selected") setSelectedVoters(new Set());
        await fetchCampaigns();
      } catch (error) {
        console.error("Bulk call error:", error);
        showNotification(
          "error",
          error.message || "Failed to initiate bulk calls"
        );
      } finally {
        setLoading(false);
        setCallProgress((prev) => ({ ...prev, isCalling: false }));
      }
    },
    [
      getFilteredVoters,
      selectedVoters,
      showNotification,
      selectedCampaign,
      fetchCampaigns,
      selectedType,
    ]
  );

  // Computed Values
  const typeStats = getTypeStatistics();
  const filteredVoters = getFilteredVoters();
  const paginatedVoters = getPaginatedVoters();
  const totalPages = Math.ceil(filteredVoters.length / votersPerPage);
  const isAllSelected =
    filteredVoters.length > 0 &&
    filteredVoters.every((voter) => selectedVoters.has(voter._id));

  // Utility Functions
  const formatNumber = (num) => new Intl.NumberFormat("en-IN").format(num);
  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  const getStatusBadge = (status) => {
    const badges = {
      not_called: { label: "Not Called", class: styles.statusNotCalled },
      completed: { label: "Completed", class: styles.statusCompleted },
      missed: { label: "Missed", class: styles.statusMissed },
    };
    const badge = badges[status] || badges.not_called;
    return (
      <span className={`${styles.statusBadge} ${badge.class}`}>
        {badge.label}
      </span>
    );
  };
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    const hours = Math.floor(mins / 60);
    const displayMins = mins % 60;
    if (hours > 0) {
      return `${hours}:${displayMins.toString().padStart(2, "0")}:${secs
        .toString()
        .padStart(2, "0")}`;
    }
    return `${displayMins}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <div className={styles.campaignManager}>
      {/* Call Progress Indicator */}
      {callProgress.isCalling && (
        <div className={styles.callProgress}>
          <div className={styles.progressHeader}>
            <h4>Bulk Calling in Progress</h4>
            <button
              onClick={() => {
                /* implement cancel logic */
              }}
              className={styles.cancelButton}
              disabled={!callProgress.isCalling}
            >
              Cancel
            </button>
          </div>
          <div className={styles.progressBarContainer}>
            <div className={styles.progressBar}>
              <div
                className={styles.progressFill}
                style={{
                  width: `${Math.min(
                    (callProgress.completedCalls / callProgress.totalCalls) *
                    100,
                    100
                  )}%`,
                }}
              ></div>
            </div>
            <span className={styles.progressPercentage}>
              {Math.round(
                (callProgress.completedCalls / callProgress.totalCalls) * 100
              )}
              %
            </span>
          </div>
          <div className={styles.progressDetails}>
            <div className={styles.detailRow}>
              <span>Chunk:</span>
              <span>
                {callProgress.currentChunk}/{callProgress.totalChunks}
              </span>
            </div>
            <div className={styles.detailRow}>
              <span>Calls:</span>
              <span>
                {callProgress.completedCalls}/{callProgress.totalCalls}
              </span>
            </div>
            <div className={styles.detailRow}>
              <span>Current Call:</span>
              <span>#{callProgress.currentCallIndex}</span>
            </div>
            <div className={styles.detailRow}>
              <span>Time:</span>
              <span>{formatTime(callProgress.elapsedTime)}</span>
            </div>
          </div>
        </div>
      )}

      {/* NEW: Enhanced Upload Progress Indicator */}
      {uploadProgress.isUploading && (
        <div className={styles.uploadProgress}>
          <div className={styles.progressHeader}>
            <div className={styles.progressHeaderLeft}>
              <FaDatabase className={styles.progressIcon} />
              <div>
                <h4>Creating Campaign</h4>
                <p className={styles.progressSubtitle}>Processing voter data with optimized batch operations</p>
              </div>
            </div>
            <div className={styles.progressStats}>
              <div className={styles.statItem}>
                <FaSpinner className={`${styles.spinner} ${styles.spinning}`} />
                <span>{uploadProgress.stage}</span>
              </div>
            </div>
          </div>

          <div className={styles.progressBody}>
            <div className={styles.progressBarContainer}>
              <div className={styles.progressBar}>
                <div
                  className={styles.progressFill}
                  style={{ width: `${uploadProgress.progress}%` }}
                />
              </div>
              <span className={styles.progressPercentage}>
                {uploadProgress.progress}%
              </span>
            </div>

            <div className={styles.progressMessage}>
              <p>{uploadProgress.message}</p>
            </div>

            <div className={styles.progressDetails}>
              <div className={styles.progressRow}>
                <div className={styles.progressCol}>
                  <div className={styles.progressItem}>
                    <FaFileAlt className={styles.progressItemIcon} />
                    <div>
                      <span className={styles.progressLabel}>Current File</span>
                      <span className={styles.progressValue}>{uploadProgress.currentFile}</span>
                    </div>
                  </div>
                </div>
                <div className={styles.progressCol}>
                  <div className={styles.progressItem}>
                    <FaDatabase className={styles.progressItemIcon} />
                    <div>
                      <span className={styles.progressLabel}>Records Processed</span>
                      <span className={styles.progressValue}>
                        {formatNumber(uploadProgress.processedRecords)} / {formatNumber(uploadProgress.totalRecords)}
                      </span>
                    </div>
                  </div>
                </div>

                <div className={styles.progressCol}>
                  <div className={styles.progressItem}>
                    <FaUpload className={styles.progressItemIcon} />
                    <div>
                      <span className={styles.progressLabel}>Processing Speed</span>
                      <span className={styles.progressValue}>{uploadProgress.avgSpeed}</span>
                    </div>
                  </div>
                </div>
                <div className={styles.progressCol}>
                  <div className={styles.progressItem}>
                    <FaClock className={styles.progressItemIcon} />
                    <div>
                      <span className={styles.progressLabel}>Est. Time Left</span>
                      <span className={styles.progressValue}>
                        {uploadProgress.estimatedTime > 0 ? formatTime(uploadProgress.estimatedTime) : "Calculating..."}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {(uploadProgress.duplicatesSkipped > 0 || uploadProgress.errors > 0) && (
                <div className={styles.progressSummary}>
                  {uploadProgress.duplicatesSkipped > 0 && (
                    <div className={styles.summaryItem}>
                      <FaExclamationTriangle className={styles.warningIcon} />
                      <span>Duplicates Skipped: {formatNumber(uploadProgress.duplicatesSkipped)}</span>
                    </div>
                  )}
                  {uploadProgress.errors > 0 && (
                    <div className={styles.summaryItem}>
                      <FaTimesCircle className={styles.errorIcon} />
                      <span>Errors: {formatNumber(uploadProgress.errors)}</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Notification */}
      {notification.show && (
        <div
          className={`${styles.notification} ${styles[notification.type]} ${styles.show
            }`}
        >
          <div className={styles.notificationContent}>
            <span className={styles.notificationIcon}>
              {notification.type === "success" && <FaCheckCircle />}
              {notification.type === "error" && <FaTimesCircle />}
              {notification.type === "warning" && <FaExclamationTriangle />}
              {notification.type === "info" && <FaInfoCircle />}
            </span>
            <span className={styles.notificationMessage}>
              {notification.message}
            </span>
          </div>
        </div>
      )}

      {!showCampaignDetails ? (
        /* Main Campaign List View */
        <main className={styles.mainContent}>
          {loading && campaigns.length === 0 ? (
            <div className={styles.loadingState}>
              <div className={styles.loadingContainer}>
                <div className={styles.spinner}></div>
                <h3>Loading Campaigns</h3>
                <p>Fetching your campaign data...</p>
                <div className={styles.loadingDots}>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          ) : campaigns.length === 0 ? (
            <div className={styles.emptyState}>
              <div className={styles.emptyStateIcon}>
                <FaVoteYea />
              </div>
              <h2>No Campaigns Yet</h2>
              <p>Create your first election campaign to get started</p>
              <button
                className={styles.primaryButton}
                onClick={() => setShowCreateForm(true)}
              >
                Create First Campaign
              </button>
            </div>
          ) : (
            <div className={styles.mainContainer}>
              <header className={styles.header}>
                <div className={styles.headerContent}>
                  <div className={styles.headerLeft}>
                    <h1 className={styles.title}>Election Campaign Manager</h1>
                    <p className={styles.subtitle}>
                      Manage your electoral campaigns efficiently
                    </p>
                  </div>
                  <div className={styles.headerRight}>
                    <button
                      className={styles.primaryButton}
                      onClick={() => setShowCreateForm(true)}
                      disabled={loading || uploadProgress.isUploading}
                    >
                      <span className={styles.buttonIcon}>
                        {uploadProgress.isUploading ? <FaSpinner className={styles.spinning} /> : <FaPlus />}
                      </span>
                      {uploadProgress.isUploading ? "Creating..." : "New Campaign"}
                    </button>
                  </div>
                </div>
              </header>

              <div className={styles.campaignsGrid}>
                {campaigns.map((campaign) => (
                  <div key={campaign._id} className={styles.campaignCard}>
                    <div className={styles.cardHeader}>
                      <div className={styles.cardHeaderLeft}>
                        <h3 className={styles.cardTitle}>
                          {campaign.leaderName}
                        </h3>
                        <p className={styles.cardSubtitle}>{campaign.partyName}</p>
                      </div>

                    </div>

                    <div className={styles.cardBody}>
                      <div className={styles.cardInfo}>
                        <div className={styles.cardInfoDetail}>
                          {/* <p>
                            <strong>Address:</strong> {campaign.leaderAddress}
                          </p> */}

                          <p>
                            <strong>Constituency:</strong> {campaign.Constituency}
                          </p>

                          <p>
                            <strong>Balance:</strong> {formatNumber(campaign.assignCredit)}
                          </p>
                        </div>

                        {campaign.ConstituencyTotalVoters && (
                          <div className={styles.coverageInfo}>
                            <div className={styles.coverageProgress}>
                              <div className={styles.progressBar}>
                                <div
                                  className={styles.progressFill}
                                  style={{
                                    width: `${Math.min((campaign.totalVoters || 0) / campaign.ConstituencyTotalVoters * 100, 100)}%`
                                  }}
                                />
                              </div>
                            </div>
                            <div className={styles.coverageInfoText}>
                              <span className={styles.coverageText}>
                                Total Voters: {formatNumber(campaign.ConstituencyTotalVoters)}
                              </span>

                              <span className={styles.coverageText}>
                                {campaign.coveragePercentage || "0.0"}% coverage
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className={styles.cardFooter}>
                      <button
                        className={styles.secondaryButton}
                        onClick={() => openCampaignDetails(campaign)}
                        disabled={loading}
                      >
                        {loading ? <FaSpinner className={styles.spinning} /> : <FaEye />} View Details
                      </button>
                      {/* <button
                        className={styles.secondaryButton}
                        onClick={() => openEditForm(campaign)}
                        disabled={loading}
                      >
                        <FaEdit /> Edit
                      </button> */}
                      <button
                        className={styles.secondaryButton}
                        onClick={() => deleteCampaign(campaign._id)}
                        disabled={loading}
                      >
                        <FaTrash /> Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </main>
      ) : (
        /* Campaign Details Modal */
        <div >
          <div onClick={closeCampaignDetails}></div>
          <div>
            <div className={styles.modalHeader}>
              <div className={styles.modalHeaderLeft}>
                {selectedType ? (
                  <button className={styles.backButton} onClick={() => {
                    setSelectedType(null)
                    setOpenHistoryId(null);
                  }}>
                    Back
                  </button>
                ) : (
                  <button className={styles.backButton} onClick={() => {

                    closeCampaignDetails();
                    setOpenHistoryId(null);


                  }}>
                    Back to Campaigns
                  </button>
                )}
              </div>
              <div className={styles.modalHeaderRight}>
                <h2>{selectedType ? selectedType.label : selectedCampaign.leaderName}</h2>
              </div>
            </div>

            <div className={styles.modalBody}>
              {!selectedType ? (
                /* Campaign Overview */
                <div className={styles.campaignOverview}>
                  {/* Campaign Info Section */}
                  <div className={styles.campaignInfo}>
                    <div className={styles.infoGrid}>
                      <div className={styles.infoCard}>
                        <h4>Contact Information</h4>
                        <p><strong>Address:</strong> {selectedCampaign.leaderAddress}</p>
                        <p><strong>Phone:</strong> {selectedCampaign.leaderContact}</p>
                        <p><strong>Email:</strong> {selectedCampaign.leaderEmail}</p>
                      </div>

                      <div className={styles.infoCard}>
                        <h4>Constituency Details</h4>
                        {selectedCampaign.Constituency ? (
                          <p><strong>Constituency:</strong> {selectedCampaign.Constituency}</p>
                        ) : (
                          <p>No constituency information</p>
                        )}
                        {selectedCampaign.ConstituencyTotalVoters && (
                          <>
                            <p><strong>Total Voters:</strong> {formatNumber(selectedCampaign.ConstituencyTotalVoters)}</p>
                            <div className={styles.coverageMetric}>
                              <div className={styles.coverageBar}>
                                <div
                                  className={styles.coverageFill}
                                  style={{
                                    width: `${Math.min((selectedCampaign.totalVoters || 0) / selectedCampaign.ConstituencyTotalVoters * 100, 100)}%`
                                  }}
                                />
                              </div>
                              <span>{selectedCampaign.coveragePercentage || "0.0"}% Coverage</span>
                            </div>
                          </>
                        )}
                      </div>

                      <div className={styles.infoCard}>
                        <h4>Campaign Stats</h4>
                        <p><strong>Total Voters:</strong> {formatNumber(selectedCampaign.totalVoters || 0)}</p>
                        <p><strong>Balance:</strong> {formatNumber(selectedCampaign.assignCredit || 0)}</p>
                        {selectedCampaign.createdAt && (
                          <p><strong>Created:</strong> {formatDate(selectedCampaign.createdAt)}</p>
                        )}
                        <p><strong>Created by:</strong> {selectedCampaign.createdBy?.email || "N/A"}</p>
                      </div>
                    </div>

                    {selectedCampaign.manifesto && (
                      <div className={styles.manifestoCard}>
                        <h4>Campaign Manifesto</h4>
                        <p>{selectedCampaign.manifesto}</p>
                      </div>
                    )}
                  </div>

                  {/* Voter Types Section */}
                  <div className={styles.voterTypesSection}>
                    <h3>Voter Categories</h3>
                    <div className={styles.typeCards}>
                      {voterTypes.map((type) => {
                        const stats = typeStats[type.key] || { total: 0, notCalled: 0, completed: 0, missed: 0 };
                        const Icon = type.icon;
                        return (
                          <div
                            key={type.key}
                            className={styles.typeCard}
                            onClick={() => selectVoterType(type)}
                            style={{
                              backgroundColor: type.bgColor,
                              borderColor: type.color,
                            }}
                          >
                            <div className={styles.typeCardHeader}>
                              <div className={styles.typeCardIcon} style={{ color: type.color }}>
                                <Icon />
                              </div>
                              <div className={styles.typeCardInfo}>
                                <h4>{type.label}</h4>
                                <p>{type.description}</p>
                              </div>
                              <div className={styles.typeCardCount} style={{ backgroundColor: type.color }}>
                                {stats.total}
                              </div>
                            </div>

                            {/* <div className={styles.typeCardStats}>
                              <div className={styles.statItem}>
                                <span className={styles.statValue}>{stats.notCalled}</span>
                                <span className={styles.statLabel}>Not Called</span>
                              </div>
                              <div className={styles.statItem}>
                                <span className={styles.statValue}>{stats.completed}</span>
                                <span className={styles.statLabel}>Completed</span>
                              </div>
                              <div className={styles.statItem}>
                                <span className={styles.statValue}>{stats.missed}</span>
                                <span className={styles.statLabel}>Missed</span>
                              </div>
                            </div> */}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              ) : (
                /* Voter Management Section */
                <div className={styles.voterManagement}>
                  {campaignDetailsLoading ? (
                    <div className={styles.loadingState}>
                      <div className={styles.loadingContainer}>
                        <div className={styles.spinner}></div>
                        <h3>Loading Voter Details</h3>
                        <p>Fetching {selectedType.label} data...</p>
                        <div className={styles.loadingDots}>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      {/* Search and Filter Controls */}
                      <div className={styles.voterControls}>
                        <div className={styles.searchAndFilter}>
                          <button
                            className={`${styles.primaryButton} ${loading || selectedCampaign?.assignCredit === 0
                              ? styles.disabled
                              : ""
                              }`}
                            onClick={() => handleBulkCall("selected")}
                            disabled={
                              selectedVoters.size === 0 ||
                              loading ||
                              selectedCampaign?.assignCredit === 0
                            }
                          >
                            <FaPhone /> Call Selected ({selectedVoters.size})
                          </button>
                          <div className={styles.searchBox}>
                            <input
                              type="text"
                              placeholder="Search voters..."
                              value={searchTerm}
                              onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(1);
                                setOpenHistoryId(null);
                              }}
                              className={styles.searchInput}
                            />
                          </div>
                          <select
                            value={statusFilter}
                            onChange={(e) => {
                              setStatusFilter(e.target.value);
                              setCurrentPage(1);
                            }}
                            className={styles.filterSelect}
                          >
                            <option value="all">All Status</option>
                            <option value="not_called">Not Called</option>
                            <option value="completed">Completed</option>
                            <option value="missed">Missed</option>
                          </select>
                        </div>
                      </div>

                      {/* Voter Table */}
                      {filteredVoters.length > 0 ? (
                        <div className={styles.voterTable}>
                          <table>
                            <thead>
                              <tr>
                                <th>
                                  <input
                                    type="checkbox"
                                    checked={isAllSelected}
                                    onChange={toggleSelectAll}
                                    disabled={loading}
                                  />
                                </th>
                                <th>Name</th>
                                <th>Contact</th>
                                <th>Address</th>
                                <th>Status</th>
                                <th>Call History </th>
                              </tr>
                            </thead>
                            <tbody>
                              {paginatedVoters.map((voter) => (
                                <tr key={voter._id}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={selectedVoters.has(voter._id)}
                                      onChange={() => toggleVoterSelection(voter._id)}
                                      disabled={loading}
                                    />
                                  </td>
                                  <td>{voter.voterName || "N/A"}</td>
                                  <td>{voter.voterContact || "N/A"}</td>
                                  <td className={styles.addressCell}>{voter.voterAddress || "N/A"}</td>
                                  <td>{getStatusBadge(voter.callStatus?.[selectedType.key] || "not_called")}</td>
                                  <td>

                                    <button className={styles.historyButton} onClick={() => setOpenHistoryId(voter._id)}>
                                      <CiViewList />
                                    </button>



                                    {openHistoryId === voter._id && (
                                      <div className={styles.popup}>
                                        <button className={styles.closeButton} onClick={() => setOpenHistoryId(null)}>
                                          ×
                                        </button>
                                        <table className={styles.table}>
                                          <thead>
                                            <tr>
                                              <th>Date</th>
                                              <th>Duration</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {getCallHistory(voter).length > 0 ? (
                                              getCallHistory(voter).map((call, idx) => (
                                                <tr key={idx}>
                                                  <td>
                                                    <span className={styles.statusIcon}>
                                                      {getCallHistoryStatusIcon(call.status)}
                                                    </span>
                                                    {call.date || "-"}
                                                  </td>
                                                  <td>{call.duration}</td>
                                                </tr>
                                              ))
                                            ) : (
                                              <tr>
                                                <td colSpan={2} className={styles.noHistory}>
                                                  No call history found.
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    )}
                                  </td>




                                </tr>
                              ))}
                            </tbody>
                          </table>

                          {/* Voter Pagination */}
                          {selectedCampaign?.voterPagination && selectedCampaign.voterPagination.voterTotalPages > 1 && (
                            <div className={styles.voterPagination}>
                              <button
                                onClick={() => handleVoterPageChange(voterPage - 1)}
                                disabled={!selectedCampaign.voterPagination.hasPrevVoterPage || campaignDetailsLoading}
                                className={styles.paginationButton}
                              >
                                Previous
                              </button>
                              <span className={styles.pageInfo}>
                                Page {voterPage} of {selectedCampaign.voterPagination.voterTotalPages}
                              </span>
                              <button
                                onClick={() => handleVoterPageChange(voterPage + 1)}
                                disabled={!selectedCampaign.voterPagination.hasNextVoterPage || campaignDetailsLoading}
                                className={styles.paginationButton}
                              >
                                Next
                              </button>
                            </div>
                          )}

                          {/* Client-side pagination for filtered results */}
                          {totalPages > 1 && (
                            <div className={styles.pagination}>
                              <button
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1 || loading}
                                className={styles.paginationButton}
                              >
                                Previous
                              </button>
                              <div className={styles.pageNumbers}>
                                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                  const page = Math.max(1, currentPage - 2) + i;
                                  if (page > totalPages) return null;
                                  return (
                                    <button
                                      key={page}
                                      onClick={() => setCurrentPage(page)}
                                      disabled={loading}
                                      className={`${styles.pageNumber} ${currentPage === page ? styles.active : ""}`}
                                    >
                                      {page}
                                    </button>
                                  );
                                })}
                              </div>
                              <button
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                disabled={currentPage === totalPages || loading}
                                className={styles.paginationButton}
                              >
                                Next
                              </button>
                            </div>
                          )}

                          <div className={styles.tableFooter}>
                            Showing {((currentPage - 1) * votersPerPage) + 1} to {Math.min(currentPage * votersPerPage, filteredVoters.length)} of {filteredVoters.length} voters
                          </div>
                        </div>
                      ) : (
                        <div className={styles.emptyState}>
                          <div className={styles.emptyStateIcon}>
                            <FaSearch />
                          </div>
                          <h3>No voters found</h3>
                          <p>
                            {selectedType.key === "promise"
                              ? "No voters with completed query calls"
                              : "Try adjusting your search or filter criteria"
                            }
                          </p>
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Create Form Modal */}
      {showCreateForm && (
        <div className={styles.modal}>
          <div
            className={styles.modalOverlay}
            onClick={() => !uploadProgress.isUploading && setShowCreateForm(false)}
          ></div>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <h2>Create New Campaign</h2>
              <button
                className={styles.modalClose}
                onClick={() => !uploadProgress.isUploading && setShowCreateForm(false)}
                disabled={uploadProgress.isUploading}
              >
                ×
              </button>
            </div>
            <form onSubmit={handleFormSubmit} className={styles.form}>
              <div className={styles.formSection}>
                <h3 className={styles.sectionTitle}>Basic Information</h3>
                <div className={styles.formGrid}>
                  <div className={styles.formGroup}>
                    <label className={styles.label}>Leader Name *</label>
                    <input
                      type="text"
                      name="leaderName"
                      value={formData.leaderName}
                      onChange={handleInputChange}
                      className={`${styles.input} ${formErrors.leaderName ? styles.inputError : ""
                        }`}
                      placeholder="Enter leader name"
                      disabled={uploadProgress.isUploading}
                    />
                    {formErrors.leaderName && (
                      <span className={styles.errorText}>
                        {formErrors.leaderName}
                      </span>
                    )}
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.label}>Party Name *</label>
                    <input
                      type="text"
                      name="partyName"
                      value={formData.partyName}
                      onChange={handleInputChange}
                      className={`${styles.input} ${formErrors.partyName ? styles.inputError : ""
                        }`}
                      placeholder="Enter party name"
                      disabled={uploadProgress.isUploading}
                    />
                    {formErrors.partyName && (
                      <span className={styles.errorText}>
                        {formErrors.partyName}
                      </span>
                    )}
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.label}>Contact Number</label>
                    <input
                      type="tel"
                      name="leaderContact"
                      value={formData.leaderContact}
                      onChange={handleInputChange}
                      className={`${styles.input} ${formErrors.leaderContact ? styles.inputError : ""
                        }`}
                      placeholder="Enter contact number"
                      disabled={uploadProgress.isUploading}
                    />
                    {formErrors.leaderContact && (
                      <span className={styles.errorText}>
                        {formErrors.leaderContact}
                      </span>
                    )}
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.label}>Email Address</label>
                    <input
                      type="email"
                      name="leaderEmail"
                      value={formData.leaderEmail}
                      onChange={handleInputChange}
                      className={`${styles.input} ${formErrors.leaderEmail ? styles.inputError : ""
                        }`}
                      placeholder="Enter email address"
                      disabled={uploadProgress.isUploading}
                    />
                    {formErrors.leaderEmail && (
                      <span className={styles.errorText}>
                        {formErrors.leaderEmail}
                      </span>
                    )}
                  </div>
                </div>
                <div className={styles.formGroup}>
                  <label className={styles.label}>Address *</label>
                  <textarea
                    name="leaderAddress"
                    value={formData.leaderAddress}
                    onChange={handleInputChange}
                    className={`${styles.textarea} ${formErrors.leaderAddress ? styles.inputError : ""
                      }`}
                    placeholder="Enter complete address"
                    rows="3"
                    disabled={uploadProgress.isUploading}
                  />
                  {formErrors.leaderAddress && (
                    <span className={styles.errorText}>
                      {formErrors.leaderAddress}
                    </span>
                  )}
                </div>
              </div>
              <div className={styles.formSection}>
                <h3 className={styles.sectionTitle}>
                  Constituency Information
                </h3>
                <div className={styles.formGrid}>
                  <div className={styles.formGroup}>
                    <label className={styles.label}>Constituency</label>
                    <input
                      type="text"
                      name="Constituency"
                      value={formData.Constituency}
                      onChange={handleInputChange}
                      className={styles.input}
                      placeholder="Enter constituency name"
                      disabled={uploadProgress.isUploading}
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.label}>
                      Total Constituency Voters
                    </label>
                    <input
                      type="text"
                      name="ConstituencyTotalVoters"
                      value={formData.ConstituencyTotalVoters}
                      onChange={handleInputChange}
                      className={`${styles.input} ${formErrors.ConstituencyTotalVoters
                        ? styles.inputError
                        : ""
                        }`}
                      placeholder="Enter total voters"
                      disabled={uploadProgress.isUploading}
                    />
                    {formErrors.ConstituencyTotalVoters && (
                      <span className={styles.errorText}>
                        {formErrors.ConstituencyTotalVoters}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className={styles.formSection}>
                <h3 className={styles.sectionTitle}>Campaign Details</h3>
                <div className={styles.formGroup}>
                  <label className={styles.label}>Manifesto</label>
                  <textarea
                    name="manifesto"
                    value={formData.manifesto}
                    onChange={handleInputChange}
                    className={styles.textarea}
                    placeholder="Enter campaign manifesto and promises"
                    rows="4"
                    disabled={uploadProgress.isUploading}
                  />
                </div>
                <div className={styles.formGroup}>
                  <label className={styles.label}>Voter Data Files *</label>
                  <div className={styles.fileUpload}>
                    <input
                      type="file"
                      multiple
                      accept=".xlsx,.xls"
                      onChange={handleFileChange}
                      className={styles.fileInput}
                      id="voter-files"
                      disabled={uploadProgress.isUploading}
                    />
                    <label
                      htmlFor="voter-files"
                      className={`${styles.fileLabel} ${formErrors.files ? styles.inputError : ""
                        } ${uploadProgress.isUploading ? styles.disabled : ""}`}
                    >
                      <span className={styles.fileIcon}>
                        <FaFolder />
                      </span>
                      <span>Choose Excel files or drag and drop</span>
                    </label>
                  </div>
                  {formErrors.files && (
                    <span className={styles.errorText}>{formErrors.files}</span>
                  )}
                  {files.length > 0 && (
                    <div className={styles.fileList}>
                      {files.map((file, index) => (
                        <div key={index} className={styles.fileItem}>
                          <span className={styles.fileName}>
                            <FaFileAlt /> {file.name}
                          </span>
                          <span className={styles.fileSize}>
                            {(file.size / 1024).toFixed(1)} KB
                          </span>
                          <button
                            type="button"
                            className={styles.discardButton}
                            onClick={() => handleDiscardFile(index)}
                            title={`Remove ${file.name}`}
                            disabled={uploadProgress.isUploading}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className={styles.formActions}>
                <button
                  type="button"
                  className={styles.secondaryButton}
                  onClick={() => setShowCreateForm(false)}
                  disabled={uploadProgress.isUploading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className={styles.primaryButton}
                  disabled={loading || uploadProgress.isUploading}
                >
                  {uploadProgress.isUploading ? (
                    <>
                      <FaSpinner className={`${styles.spinner} ${styles.spinning}`} />
                      Creating Campaign...
                    </>
                  ) : loading ? (
                    <>
                      <FaSpinner className={`${styles.spinner} ${styles.spinning}`} />
                      Processing...
                    </>
                  ) : (
                    "Create Campaign"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Form Modal */}
      {showEditForm && (
        <div className={styles.modal}>
          <div
            className={styles.modalOverlay}
            onClick={() => setShowEditForm(false)}
          ></div>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <h2>Edit Campaign</h2>
              <button
                className={styles.modalClose}
                onClick={() => setShowEditForm(false)}
              >
                ×
              </button>
            </div>
            <form onSubmit={handleEditFormSubmit} className={styles.form}>
              <div className={styles.formSection}>
                <h3 className={styles.sectionTitle}>Basic Information</h3>
                <div className={styles.formGrid}>
                  <div className={styles.formGroup}>
                    <label className={styles.label}>Leader Name *</label>
                    <input
                      type="text"
                      name="leaderName"
                      value={formData.leaderName}
                      onChange={handleInputChange}
                      className={`${styles.input} ${formErrors.leaderName ? styles.inputError : ""
                        }`}
                      placeholder="Enter leader name"
                    />
                    {formErrors.leaderName && (
                      <span className={styles.errorText}>
                        {formErrors.leaderName}
                      </span>
                    )}
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.label}>Party Name *</label>
                    <input
                      type="text"
                      name="partyName"
                      value={formData.partyName}
                      onChange={handleInputChange}
                      className={`${styles.input} ${formErrors.partyName ? styles.inputError : ""
                        }`}
                      placeholder="Enter party name"
                    />
                    {formErrors.partyName && (
                      <span className={styles.errorText}>
                        {formErrors.partyName}
                      </span>
                    )}
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.label}>Contact Number</label>
                    <input
                      type="tel"
                      name="leaderContact"
                      value={formData.leaderContact}
                      onChange={handleInputChange}
                      className={`${styles.input} ${formErrors.leaderContact ? styles.inputError : ""
                        }`}
                      placeholder="Enter contact number"
                    />
                    {formErrors.leaderContact && (
                      <span className={styles.errorText}>
                        {formErrors.leaderContact}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className={styles.formSection}>
                <h3 className={styles.sectionTitle}>Campaign Details</h3>
                <div className={styles.formGroup}>
                  <label className={styles.label}>Manifesto</label>
                  <textarea
                    name="manifesto"
                    value={formData.manifesto}
                    onChange={handleInputChange}
                    className={styles.textarea}
                    placeholder="Enter campaign manifesto and promises"
                    rows="4"
                  />
                </div>
              </div>
              <div className={styles.formActions}>
                <button
                  type="button"
                  className={styles.secondaryButton}
                  onClick={() => setShowEditForm(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className={styles.primaryButton}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <FaSpinner className={`${styles.spinner} ${styles.spinning}`} />
                      Updating...
                    </>
                  ) : (
                    "Update Campaign"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CampaignManager;

